<template>
  <div class="container public">
    <page-header />
    <div class="content-container">
      <!-- <div class="main-title">
       <h2 class="section-title">{{ $t('homePage.title') }}</h2>
      </div> -->
      <div class="main-section">
        <!-- Page mode switcher -->
        <div style="display: flex;  margin-top: -15px; margin-bottom: 8px; margin-left: -15px; margin-right: -15px; border: 1px solid #ced4da; border-radius: 0.375rem; overflow: hidden;">
          <button type="button" :class="pageMode === 'monitoring' ? 'btn btn-primary' : 'btn btn-outline-secondary'" style="flex: 1; border-radius: 0; border: none;" @click="pageMode = 'monitoring'">
            <font-awesome-icon icon="tachometer-alt" /> &nbsp; {{ $t('homePage.monitoring') }}
          </button>
          <button type="button" :class="pageMode === 'reports' ? 'btn btn-primary' : 'btn btn-outline-secondary'" style="flex: 1; border-radius: 0; border: none; border-left: 1px solid #ced4da;" @click="pageMode = 'reports'">
            <font-awesome-icon icon="file" /> &nbsp; {{ $t('homePage.reports') }}
          </button>
          <button type="button" :class="[pageMode === 'dashboard' ? 'btn btn-primary' : 'btn btn-outline-secondary', !client.dashboardIncluded ? 'report-locked' : '']" style="flex: 1; border-radius: 0; border: none; border-left: 1px solid #ced4da;" @click="client.dashboardIncluded ? pageMode = 'dashboard' : null">
            <font-awesome-icon icon="th-large" /> &nbsp; {{ $t('homePage.dashboard') }}
            <font-awesome-icon v-if="!client.dashboardIncluded" icon="lock" class="lock-icon" v-title="$t('homePage.dashboardNotIncluded')" />
          </button>
        </div>
        <!-- Monitoring toolbar -->
        <template v-if="pageMode === 'monitoring'">
          <div class="btn-toolbar" v-if="!currentFacility" style="gap: 0; margin-bottom: 8px; margin-left: -15px;">
            <button type="button" class="btn btn-primary mr-3" @click="loadLatestCDCDataValues()">
              <font-awesome-icon icon="history" /> &nbsp; {{ $t('homePage.updateLatestData') }}
            </button>
            <div id="reloadContainer">
              <div id="reloadText"><span id="smallRefreshText">60s</span></div>
              <div id="infoReload">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgba(255, 255, 255, 0); display: block;" width="32px" height="32px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <g>
                  <path d="M50 18A32 32 0 1 0 72.62741699796953 27.372583002030485" fill="none" stroke="#6695c2" stroke-width="8"></path>
                  <path d="M49 0L49 36L67 18L49 0" fill="#6695c2"></path>
                  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="50s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                </g>
                </svg>
              </div>
            </div>
            <span v-show="isLoading || latestDataPending"><button class="btn btn-primary"><span class="spinner-border spinner-border-sm"></span></button><span> {{ $t('homePage.isLoading') }} </span></span>
            <span v-show="isPreparing" :key="isPreparing"><button class="btn btn-primary"><span class="spinner-border spinner-border-sm"></span></button><span> {{ $t('homePage.isPreparing') }} </span></span>
          </div>
          <div class="btn-toolbar" style="gap: 0; margin-bottom: 8px; margin-left: -15px;" v-else>
            <button v-if="!sensorMode" type="button" class="btn btn-info mr-3" @click="backToOverview()">
              <font-awesome-icon icon="arrow-alt-circle-left" /> &nbsp; {{ $t('homePage.backToOverview') }}
            </button>
            <button v-else type="button" class="btn btn-info mr-3" @click="backToFacility()">
              <font-awesome-icon icon="arrow-alt-circle-left" /> &nbsp; {{ $t('homePage.backToFacility') }}
            </button>&nbsp;
            <button type="button" class="btn btn-primary mr-3" @click="loadLatestCDCDataValues()">
              <font-awesome-icon icon="history" /> &nbsp; {{ $t('homePage.updateLatestData') }}
            </button>
            <div id="reloadContainer">
              <div id="reloadText"><span id="smallRefreshText">60s</span></div>
              <div id="infoReload">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgba(255, 255, 255, 0); display: block;" width="32px" height="32px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <g>
                  <path d="M50 18A32 32 0 1 0 72.62741699796953 27.372583002030485" fill="none" stroke="#6695c2" stroke-width="8"></path>
                  <path d="M49 0L49 36L67 18L49 0" fill="#6695c2"></path>
                  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="50s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                </g>
                </svg>
              </div>
            </div>
            <span v-show="isLoading || latestDataPending"><button class="btn btn-primary"><span class="spinner-border spinner-border-sm"></span></button><span> {{ $t('homePage.isLoading') }} </span></span>
            <span v-show="isPreparing" :key="isPreparing"><button class="btn btn-primary"><span class="spinner-border spinner-border-sm"></span></button><span> {{ $t('homePage.isPreparing') }} </span></span>
          </div>
        </template>
        <error-row @clearError="clearError" :errorMessage="errorMessage" />
        <!-- Dashboard lives in its own component — HomePage only hosts the tab -->
        <dashboard-panel v-if="pageMode === 'dashboard'" @openFacility="openFacilityFromDashboard" />
      <div v-if="pageMode === 'reports'" style="gap: 8px; margin-bottom: 8px; margin-left: -15px;" >
          <!-- Report type selector -->
          <div class="btn-toolbar" style="gap: 8px; margin-bottom: 12px;">
            <button type="button" :class="scopeReportType === 'daily' ? 'btn btn-primary' : 'btn btn-outline-secondary'" @click="scopeReportType = 'daily'" style="width: 200px;">
              <font-awesome-icon icon="calendar-day" /> &nbsp; {{ $t('homePage.dailyTotals') }}
            </button>
            <button type="button" :class="[scopeReportType === 'co2' ? 'btn btn-primary' : 'btn btn-outline-secondary', !client.co2ReportIncluded ? 'report-locked' : '']" @click="client.co2ReportIncluded ? scopeReportType = 'co2' : null" style="width: 200px;">
              <font-awesome-icon icon="leaf" /> &nbsp; {{ $t('homePage.co2Report') }}
              <font-awesome-icon v-if="!client.co2ReportIncluded" icon="lock" class="lock-icon" v-title="$t('homePage.reportNotIncluded')" />
            </button>
            <button type="button" :class="[scopeReportType === 'usage' ? 'btn btn-primary' : 'btn btn-outline-secondary', !client.usageReportIncluded ? 'report-locked' : '']" @click="client.usageReportIncluded ? scopeReportType = 'usage' : null" style="width: 200px;">
              <font-awesome-icon icon="tachometer-alt" /> &nbsp; {{ $t('homePage.usageReport') }}
              <font-awesome-icon v-if="!client.usageReportIncluded" icon="lock" class="lock-icon" v-title="$t('homePage.reportNotIncluded')" />
            </button>
            <button type="button" :class="scopeReportType === 'meterplan' ? 'btn btn-primary' : 'btn btn-outline-secondary'" @click="scopeReportType = 'meterplan'" style="width: 200px;">
              <font-awesome-icon icon="th-large" /> &nbsp; {{ $t('homePage.meterPlan') }}
            </button>
          </div>
          <div class="btn-toolbar" style="align-items: center; gap: 8px;">
            <div>
              <VueDatePicker v-if="scopeReportType !== 'daily' && scopeReportType !== 'meterplan'" v-model="reportFirstDate" :enable-time-picker="false" model-type="yyyy-MM-dd" :auto-apply="true"/>
            </div>
            <div>
              <VueDatePicker v-model="reportLastDate" :enable-time-picker="false" model-type="yyyy-MM-dd" :auto-apply="true" />
            </div>
            <select v-if="scopeReportType === 'meterplan'" class="form-control" v-model="meterPlanMonths" style="width: auto;">
              <option v-for="n in [3, 6, 12, 18, 24]" :key="n" :value="n">{{ n }} {{ $t('homePage.months') }}</option>
            </select>
            <select class="form-control" v-model="reportFacilityId" style="width: auto;">
              <option disabled value="">{{ $t('homePage.selectFacility') }}</option>
              <option v-for="facility in facilitiesLocal" :key="facility.id" :value="facility.id">{{ facility.name }}</option>
            </select>
            <button type="button" class="btn btn-info" @click="loadScopeReport()">
              {{ $t('homePage.loadReport') }}
            </button>
            <button type="button" class="btn btn-warning" v-if="scopeReportType !== 'meterplan'" @click="mainOnly = !mainOnly">
              <font-awesome-icon icon="filter" /> &nbsp; {{ mainOnly ? $t('homePage.allSensors') : $t('homePage.mainOnly') }}
            </button>
            <button type="button" class="btn btn-info" @click="printScopeReport()" :disabled="!filteredTotals.length || scopeReportType === 'meterplan'">
              <font-awesome-icon icon="print" /> <!-- &nbsp; {{ $t('homePage.print') }} -->
            </button>
            <button type="button" class="btn btn-info action_btn" @click="downloadScopeReportTSV()" :disabled="!reportEntryCount">
              <font-awesome-icon icon="arrow-up-from-bracket" /> <!-- &nbsp; Download -->
            </button>
          </div>
          <!-- Spinner / entry count / no-data -->
          <div v-if="scopeReportLoading" style="margin-top: 12px;">
            <span class="spinner-border spinner-border-sm"></span> {{ $t('homePage.isLoading') }}
          </div>
          <div v-else-if="scopeReportLoaded && !reportEntryCount" class="small text-muted" style="margin-top: 12px;">
            {{ $t('homePage.noReportData') }}
          </div>
          <div v-else-if="reportEntryCount" class="small text-muted" style="margin-top: 8px;">{{ reportEntryCount }} {{ $t('homePage.reportEntries') }}<span v-if="scopeReportType === 'meterplan'"> &mdash; {{ $t('homePage.nearestReadingHint', { slack: meterPlan.slackDays }) }}</span></div>
          <!-- CO2 Report table -->
          <table v-if="!scopeReportLoading && scopeReportType === 'co2' && filteredTotals.length" class="meter-readings" style="margin-top: 10px;">
            <tr>
              <th>{{ $t('homePage.type') }}</th>
              <th>{{ $t('homePage.sensorName') }}</th>
              <th>{{ $t('homePage.meterInfo') }}</th>
              <th>{{ $t('homePage.extSensorId') }}</th>
              <th>{{ $t('homePage.maloId') }}</th>
              <th>{{ $t('homePage.facilityName') }}</th>
              <th>{{ $t('homePage.startDate') }}</th>
              <th>{{ $t('homePage.endDate') }}</th>
              <th style="text-align: right;">{{ $t('homePage.co2e') }}</th>
              <th>{{ $t('homePage.scope') }}</th>
            </tr>
            <tr v-for="total in filteredTotals" :key="total.cdcsensorid" :class="{ 'row-main-meter': total.main }">
              <td><img :src="sensorTypeIcon(total.type)" width="20" :title="total.typestring"></td>
              <td>{{ total.sensorName }}</td>
              <td>{{ total.meterinfo }}</td>
              <td>{{ total.externalsensorid }}</td>
              <td>{{ total.maloid }}</td>
              <td>{{ total.facilityName }}</td>
              <td :style="dateOutOfScope(total.startdate, reportFirstDate) ? 'color: red;' : ''">{{ formatDate(total.startdate) }}</td>
              <td :style="dateOutOfScope(total.enddate, reportLastDate) ? 'color: red;' : ''">{{ formatDate(total.enddate) }}</td>
              <td :style="scopeDataIncomplete(total) ? 'text-align: right; color: orange;' : 'text-align: right;'">{{ $formatNumber(total.co2e, 3) }}</td>
              <td>{{ total.scope }}</td>
            </tr>
          </table>
          <!-- Usage Report table -->
          <table v-if="!scopeReportLoading && scopeReportType === 'usage' && filteredTotals.length" class="meter-readings" style="margin-top: 10px;">
            <tr>
              <th>{{ $t('homePage.type') }}</th>
              <th>{{ $t('homePage.sensorName') }}</th>
              <th>{{ $t('homePage.meterInfo') }}</th>
              <th>{{ $t('homePage.extSensorId') }}</th>
              <th>{{ $t('homePage.maloId') }}</th>
              <th>{{ $t('homePage.facilityName') }}</th>
              <th>{{ $t('homePage.startDate') }}</th>
              <th>{{ $t('homePage.endDate') }}</th>
              <th style="text-align: right;">{{ $t('homePage.total') }}</th>
              <th>{{ $t('homePage.unit') }}</th>
              <th style="text-align: right;">{{ $t('homePage.cost') }}</th>
            </tr>
            <tr v-for="total in filteredTotals" :key="total.cdcsensorid" :class="{ 'row-main-meter': total.main }">
              <td><img :src="sensorTypeIcon(total.type)" width="20" :title="total.typestring"></td>
              <td>{{ total.sensorName }}</td>
              <td>{{ total.meterinfo }}</td>
              <td>{{ total.externalsensorid }}</td>
              <td>{{ total.maloid }}</td>
              <td>{{ total.facilityName }}</td>
              <td :style="dateOutOfScope(total.startdate, reportFirstDate) ? 'color: red;' : ''">{{ formatDate(total.startdate) }}</td>
              <td :style="dateOutOfScope(total.enddate, reportLastDate) ? 'color: red;' : ''">{{ formatDate(total.enddate) }}</td>
              <td :style="scopeDataIncomplete(total) ? 'color: orange; text-align: right;' : 'text-align: right;'">{{ $formatNumber(whToKwh(total.total, total.unit), 0) }}</td>
              <td>{{ normalizeUnit(total.unit) }}</td>
              <td style="text-align: right;">{{ formatCost(total.cost) }}</td>
            </tr>
          </table>
          <!-- Daily Totals table -->
          <table v-if="!scopeReportLoading && scopeReportType === 'daily' && filteredTotals.length" class="meter-readings" style="margin-top: 10px;">
            <tr>
              <th>{{ $t('homePage.type') }}</th>
              <th>{{ $t('homePage.sensorName') }}</th>
              <th>{{ $t('homePage.meterInfo') }}</th>
              <th>{{ $t('homePage.extSensorId') }}</th>
              <th>{{ $t('homePage.maloId') }}</th>
              <th>{{ $t('homePage.facilityName') }}</th>
              <th>{{ $t('homePage.date') }}</th>
              <th style="text-align: right;">{{ $t('homePage.value') }}</th>
              <th>{{ $t('homePage.unit') }}</th>
              <th>{{ $t('homePage.obis') }}</th>
            </tr>
            <tr v-for="total in filteredTotals" :key="total.cdcsensorid" :class="{ 'row-main-meter': total.main }">
              <td><img :src="sensorTypeIcon(total.type)" width="20" :title="total.typestring"></td>
              <td>{{ total.sensorName }}</td>
              <td>{{ total.meterinfo }}</td>
              <td>{{ total.externalsensorid }}</td>
              <td>{{ total.maloid }}</td>
              <td>{{ total.facilityName }}</td>
              <td :style="dateOutOfScope(total.enddate, reportLastDate) ? 'color: red;' : ''">{{ formatDate(total.enddate) }}</td>
              <td :style="scopeDataIncomplete(total) ? 'color: orange; text-align: right;' : 'text-align: right;'">{{ $formatNumber(whToKwh(total.endvalue, total.unit), 0) }}</td>
              <td>{{ normalizeUnit(total.unit) }}</td>
              <td>{{ total.obis }}</td>
            </tr>
          </table>
          <!-- Meter plan table: one row per meter, one column per month end -->
          <table v-if="!scopeReportLoading && scopeReportType === 'meterplan' && meterPlanRows.length" class="meter-readings" style="margin-top: 10px;">
            <tr>
              <th>{{ $t('homePage.meterNumber') }}</th>
              <th>{{ $t('homePage.apu') }}</th>
              <th>{{ $t('homePage.sensorName') }}</th>
              <th>{{ $t('homePage.apartment') }}</th>
              <th>{{ $t('homePage.houseNumber') }}</th>
              <th>{{ $t('homePage.level') }}</th>
              <th>{{ $t('homePage.position') }}</th>
              <th>{{ $t('homePage.unit') }}</th>
              <th v-for="col in meterPlanColumns" :key="col.key" style="text-align: right;">{{ col.kind === 'reading' ? formatDate(col.date) : $t('homePage.consumption') }}</th>
            </tr>
            <tr v-for="row in meterPlanRows" :key="row.key">
              <td>{{ row.meterinfo }}</td>
              <td>{{ row.meta.apu }}</td>
              <td>{{ row.sensorName }}</td>
              <td>{{ row.meta.whg }}</td>
              <td>{{ row.meta.be }}</td>
              <td>{{ levelLabel(row.meta.bl) }}</td>
              <td>{{ row.meta.oid }}<span v-if="row.meta.loc"> ({{ row.meta.loc }})</span></td>
              <td>{{ normalizeUnit(row.unit) }}</td>
              <td v-for="col in meterPlanColumns" :key="col.key" :style="meterPlanCellStyle(row, col)" :title="meterPlanCellTitle(row, col)">{{ meterPlanCellText(row, col) }}</td>
            </tr>
          </table>
      </div>
      </div>

      <div class="facility-wrapper" v-if="pageMode === 'monitoring' && !currentFacility">
        <div v-for="facility in facilitiesSortedByAlerts" v-bind:key="facility.id">
          <div v-if="!facilityIsDisabled(facility) || showHiddenFacilities">
            <div class="facility-header pointer" :style="facilityStyleHasAlerts(facility)" @click="showFacility(facility)">
              <div class="facility-title"><img src="/images/facility_circle.png" width="20"><span class="facility-name">{{ facility.name }}</span> <div class="alert-reason-wrapper"><div class='alert-reason-icon' :style="facilityHasAnyAlert(facility) ? 'cursor: pointer;' : ''" @click.stop="facilityHasAnyAlert(facility) ? showAlertsForFacility(facility) : null"><img :src="facilityAlertReasons(facility).icon" :title="facilityAlertTooltip(facility)" width="20" ></div><div class="alert-reason-number" :class="{ 'facility-reason-number-inactive': facilityHideReasonNumber(facility) }">{{ facilityAlertReasons(facility).reasons.length }}</div></div><div class="edit-wrapper" v-if="userMayEdit"><font-awesome-icon icon="edit" class="edit-icon" v-title="$t('homePage.editFacility')" @click.stop="openEditFacility(facility)" /></div></div>
              <div class="facility-time"> {{ fromNowFacilityDisplay(facility) }} </div>
            </div>
          </div>
        </div>
        <div v-if="facilityDisabledCount()">
          <span class="facility-name">{{ facilityDisabledCount() }}</span> {{ $t('homePage.disabledFacilities') }}<button class="btn btn-sm" @click="toggleShowHiddenFacilities">{{ $t('homePage.showHideHidden') }}</button>
        </div>
      </div>
      <div class="facility-wrapper" v-if="pageMode === 'monitoring' && currentFacility">
        <!--<div class="facility-header" :class="{ 'facility-header-suspect': facilityIsOutdated(currentFacility),  'facility-header-sub-suspect': facilityHasAlerts(currentFacility), 'facility-header-inactive': facilityIsDisabled(currentFacility) }">-->
         <div style="position: relative;">
          <div class="facility-header" :style="facilityStyleHasAlerts(currentFacility)">
              <div class="facility-title"><img src="/images/facility_circle.png" width="20"><span class="facility-name">{{ currentFacility.name }}</span>
              <div class="location-wrapper" v-if="hasCoordinates(currentFacility)"><button class="btn btn-sm" @click="openInAppleMap(currentFacility)"><img class="location-image" src="/images/Location_black.png"></button></div><div class="alert-reason-wrapper"><div class='alert-reason-icon' :style="facilityHasAnyAlert(currentFacility) ? 'cursor: pointer;' : ''" @click.stop="facilityHasAnyAlert(currentFacility) ? showAlertsForFacility(currentFacility) : null"><img :src="facilityAlertReasons(currentFacility).icon" :title="facilityAlertTooltip(currentFacility)" width="20" ></div><div class="alert-reason-number" :class="{ 'facility-reason-number-inactive': facilityHideReasonNumber(currentFacility) }">{{ facilityAlertReasons(currentFacility).reasons.length }}</div></div><div class="edit-wrapper" v-if="userMayEdit"><font-awesome-icon icon="edit" class="edit-icon" v-title="$t('homePage.editFacility')" @click.stop="openEditFacility(currentFacility)" /></div></div>
              <div class="facility-time"> {{ fromNowFacilityDisplay(currentFacility) }}</div>
          </div>
          <div class="facility-details" v-if="showFacilityDetail">
            <div class="facility-detail-wrapper">
              <div><img class="facility-image" :src="facilityImagePath(currentFacility)"></div>
              <div v-if="hasCoordinates(currentFacility)">
                <!--<p><button class="btn btn-outline-info btn-sm" @click="showMapSnapshot(currentFacility)">{{ $t('facilitiesPage.showMapSnapshot') }}</button><p>-->
              </div>
            </div>
          </div>
         </div>

        <div class = "device-wrapper" v-if="!sensorMode">
          <div v-for="device in visibleDevices(currentFacility)" v-bind:key="device.id">
            <div class="device-item" :style="deviceStyleHasAlerts(device)">
              <div class="device-headline"><img src="/images/cdc_circle.png" width="20"><span class="device-name">{{ deviceName(device) }}</span> <div class="alert-reason-wrapper"><div class='alert-reason-icon' :style="deviceHasAnyAlert(device) ? 'cursor: pointer;' : ''" @click.stop="deviceHasAnyAlert(device) ? showAlertsForDevice(device) : null"><img :src="deviceAlertReason(device).icon" :title="deviceAlertTooltip(device)" width="20" ></div><div class="alert-reason-number" :class="{ 'device-reason-number-inactive': deviceHideReasonNumber(device) }">{{ deviceAlertReason(device).reasons.length }}</div></div><div class="edit-wrapper" v-if="userMayEdit && !device.virtual"><font-awesome-icon icon="edit" class="edit-icon" v-title="$t('homePage.editController')" @click.stop="openEditDevice(device)" /></div></div>
              <div class="device-time">{{ fromNowDeviceDisplay(device) }}</div>
            </div>
            <div class = "sensor-wrapper">
              <div v-for="sensor in visibleSensors(device)" v-bind:key="sensor.id"
                   class="sensor-card"
                   :class="{ pointer: dataPackageForSensor(sensor) || isVirtualSensor(sensor) }"
                   :style="sensorStyleAlertStatus(sensor)"
                   @click="(dataPackageForSensor(sensor) || isVirtualSensor(sensor)) ? showSensor(sensor) : null">
                <div class="sensor-item-headline" :class="{ 'sensor-item-inactive': !sensor.enabled }">
                  <div><img :src="sensorIcon(sensor)" width="20"><span class="sensor-name">{{ sensor.name }}</span><font-awesome-icon v-if="sensor.main" icon="building" v-title="$t('homePage.mainMeter')" style="float:right; margin-left: 0.5em;" /><img :src="sensorAlertIcon(sensor)" :title="alertIconTooltip(sensor)" width="20" :style="sensorHasAnyAlert(sensor) ? 'float:right; margin-left: 0.5em; cursor: pointer;' : 'float:right; margin-left: 0.5em;'" @click.stop="sensorHasAnyAlert(sensor) ? showAlertsForSensor(sensor) : null"><font-awesome-icon v-if="userMayEdit" icon="edit" class="edit-icon" style="float:right; margin-left: 0.5em;" v-title="$t('homePage.editSensor')" @click.stop="openEditSensor(sensor)" /></div>
                </div>
                <div class="sensor-item-content">
                  <div v-if="false && sensorHasTotal(sensor)"><!-- FIXME!!! -->
                    <div class="sensor-item-value"> {{ $t('homePage.headlineSensorTotalSection') }} </div>
                    <div class="sensor-item-system"> {{ totalSensorSystemDisplay(sensor) }} </div>
                    <div class="sensor-item-value"> {{ totalSensorValueDisplay(sensor) }} <span class="sensor-item-unit"> {{ totalSensorUnitDisplay(sensor) }} ( {{ totalSensorAccuracyDisplay(sensor) }} % {{ $t('homePage.missingRatioText') }})</span></div>
                    <div class="sensor-item-time"> {{ totalFromNowSensorDisplay(sensor) }} </div>
                  </div>
                  <div v-else>
                    <template v-if="dataPackageForSensor(sensor)">
                      <div class="sensor-item-system"> {{ sensorSystemDisplay(sensor) }} </div>
                      <div class="sensor-item-value"> {{ sensorValueDisplay(sensor) }} <span class="sensor-item-unit"> {{ sensorUnitDisplay(sensor) }} </span></div>
                      <div class="sensor-item-time"> {{ fromNowSensorDisplay(sensor) }} </div>
                    </template>
                    <template v-else>
                      <div class="sensor-item-value"> {{ sensor.model }} </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- COLLECTION ADDRESS SECTION -->
            <div v-if="hasCollections(device)" class = "collections-wrapper">
              <div class = "sensor-wrapper">
                <div v-for="collection in visibleCollections(device)" v-bind:key="collection.id"
                     class="sensor-card pointer"
                     :style="sensorStyleAlertStatus(collection)"
                     @click="showSensor(collection)">
                  <div class="sensor-item-headline" :class="{ 'sensor-item-suspect': sensorIsOutdated(collection), 'sensor-item-inactive': !collection.enabled }">
                    <div><img :src="collectionIcon(collection)" width="20"><span class="sensor-name">{{ collection.name }}</span></div>
                  </div>
                  <div class="sensor-item-content">
                    <div class="sensor-item-system"> {{ sensorSystemDisplay(collection) }} </div>
                    <div class="sensor-item-value"> {{ sensorValueDisplay(collection) }} <span class="sensor-item-unit"> {{ sensorUnitDisplay(collection) }} </span></div>
                    <div class="sensor-item-time"> {{ fromNowSensorDisplay(collection) }} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class = "device-wrapper" v-if="sensorMode">
          <div class="device-item" :style="deviceStyleHasAlerts(currentDevice)">
            <div class="device-headline"><img src="/images/cdc_circle.png" width="20"><span class="device-name">{{ deviceName(currentDevice) }}</span><div class="alert-reason-wrapper"><div class='alert-reason-icon' :style="deviceHasAnyAlert(currentDevice) ? 'cursor: pointer;' : ''" @click.stop="deviceHasAnyAlert(currentDevice) ? showAlertsForDevice(currentDevice) : null"><img :src="deviceAlertReason(currentDevice).icon" :title="deviceAlertTooltip(currentDevice)" width="20" ></div><div class="alert-reason-number" :class="{ 'device-reason-number-inactive': deviceHideReasonNumber(currentDevice) }">{{ deviceAlertReason(currentDevice).reasons.length }}</div></div><div class="edit-wrapper" v-if="userMayEdit && !currentDevice.virtual"><font-awesome-icon icon="edit" class="edit-icon" v-title="$t('homePage.editController')" @click.stop="openEditDevice(currentDevice)" /></div></div>
            <div class="device-time">{{ fromNowDeviceDisplay(currentDevice) }}</div>
          </div>
          <div class = "device-item" :style="sensorStyleAlertStatus(currentSensor)" :class="{ 'sensor-item-inactive': !currentSensor.enabled }">
            <div class="device-headline">
              <div><img :src="sensorIcon(currentSensor)" width="20"><span class="sensor-name">{{ currentSensor.name }}</span><span v-if="currentSensor.meterinfo" class="sensor-meterinfo">{{ $t('homePage.meterId') }}: {{ currentSensor.meterinfo }}</span></div>
            </div>
          </div>
          <div class = "sensor-wrapper">
            <div v-if="providesFirstGlanceData(currentSensor) && (!isVirtualSensor(currentSensor) || isComputedSensor(currentSensor))" class="sensor-value-content-not-hidden graph-content">
              <div v-show="statsDataLoading && !hasSensorAggregations"><span class="spinner-border spinner-border-sm"></span> {{ $t('homePage.loadingStatsData') }}</div>
              <div v-show="chartDataLoading && !hasCdcdatavalues"><span class="spinner-border spinner-border-sm"></span> {{ $t('homePage.loadingChartData') }}</div>
              <div v-show="currentSensor.id >= 0">
                <div v-show="showChartOptions">
                  <div class="btn-toolbar">
                      <div>
                        <button type="button" class="btn btn-light mr-3" @click="toggleShowChartOptions()">{{ $t('homePage.hideChartOptions') }}</button>
                        <br>
                      </div>
                      <div v-if="chartViewStatus === 1">
                        <button v-if="chartDuration <= 1" type="button" class="btn btn-light mr-3" @click="toggleChartDuration()">{{ $t('homePage.showDay') }}</button>
                        <button v-if="chartDuration > 1" type="button" class="btn btn-light mr-3" @click="toggleChartDuration()">{{ $t('homePage.showHour') }}</button>
                        <br>
                      </div>
                      <div v-if="chartViewStatus === 2">
                        <button type="button" class="btn btn-light mr-3" @click="toggleStatsDuration()">{{ $t('homePage.WocheMonat') }}</button>
                        <br>
                      </div>
                      <div class="btn-toolbar">
                        <div>
                          <button type="button" class="btn btn-light mr-3" @click="previousChart()">&larr;</button><br>
                        </div>
                        <div>
                          <VueDatePicker v-model="selectedChartDateFromPicker" :enable-time-picker="chartDuration === 1" :model-type="chartDuration === 1 ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd'" :auto-apply="true" />
                          <br>
                        </div>
                        <div>&nbsp;&nbsp;</div>
                        <div>
                          <button type="button" class="btn btn-light mr-3" @click="nextChart()">&rarr;</button><br>
                        </div>
                      </div>
                      <div v-if="chartViewStatus === 1">
                         <select class="form-control" id="systemPartAndTypeSelect" v-model="selectedCharts" multiple>
                           <option v-for="item in chartDisplayValues" :value="item" :key="item.text">
                             {{ item.text }}
                           </option>
                         </select>
                         <p class="smallText">Multi Chart ist noch BETA!</p>
                      </div>
                      <div>&nbsp;</div>
                      <div v-if="chartViewStatus === 1">
                        <div>
                          <button type="button" class="btn btn-info action_btn" v-on:click="downloadTSVChartData">{{ $t('homePage.downloadData') }}</button>&nbsp;
                       </div>
                     </div>
                     <div v-if="chartViewStatus === 2">
                       <div>
                         <button type="button" class="btn btn-info action_btn" v-on:click="downloadTSVDayStatsData">{{ $t('homePage.downloadData') }}</button>&nbsp;
                      </div>
                     </div>
                    </div>
                    <div class="spacer">&nbsp;</div>
                    <div v-if="chartViewStatus === 1">
                      <button type="button" class="btn btn-light mr-3" @click="toggleChartView()">{{ $t('homePage.showStatsView') }}</button>
                    </div>
                    <div v-else>
                      <button type="button" class="btn btn-light mr-3" @click="toggleChartView()">{{ $t('homePage.showDataView') }}</button>
                    </div>

                </div>
                <div v-show="!showChartOptions">
                  <div class="btn-toolbar">
                    <button type="button" class="btn btn-light mr-3" @click="toggleShowChartOptions()">{{ $t('homePage.chartOptions') }}</button>
                    <div class="centeredText">{{ formatedChartDate() }} </div>
                    <!--<div class="spacer">&nbsp;</div>-->
                    <div v-if="chartViewStatus === 1">
                      <button type="button" class="btn btn-light mr-3" @click="toggleChartView()">{{ $t('homePage.showStatsView') }}</button>
                    </div>
                    <div v-else>
                      <button type="button" class="btn btn-light mr-3" @click="toggleChartView()">{{ $t('homePage.showDataView') }}</button>
                    </div>
                  </div>
                </div>
                <div v-show="chartViewStatus === 1 && hasCdcdatavalues">
                  <div>
                    <div v-show="chartDataLoading"><span class="spinner-border spinner-border-sm"></span> {{ $t('homePage.loadingChartData') }}</div>
                    <div v-show="!chartDataLoading">&nbsp;</div>
                  </div>
                    <div v-if="!chartDataLoading && chartDataSets(currentSensor).length === 0" class="text-muted text-center py-4">
                      {{ $t('homePage.noChartData') }}
                    </div>
                    <div v-if="(currentSensor.type === 1 || currentSensor.type === 2) && chartDataSets(currentSensor).length > 0">
                     <column-chart :data="chartDataSets(currentSensor)" :dataset="barChartDataSet()" :library="barChartOptions()" :download="true" />
                    </div>
                    <div v-if="(currentSensor.type === 0 || currentSensor.type > 2) && chartDataSets(currentSensor).length > 0">
                     <!-- <area-chart :data="chartDataSets(currentSensor)" :options="chartOptions()" :download="true" ></area-chart> -->
                     <area-chart :data="chartDataSets(currentSensor)" :dataset="areaChartDataSet()" :library="chartOptions()" :download="true" ></area-chart>
                    </div>
                </div>
                <div v-if="chartViewStatus === 1 && currentSensor.id >= 0 && !isVirtualSensor(currentSensor)" class="observation-list">
                  <div class="observation-head">
                    <span class="observation-title">{{ $t('homePage.observationsTitle') }}</span>
                    <span v-if="userMayEdit && supportsChartClick" class="small text-muted">{{ $t('homePage.clickHint') }}</span>
                  </div>
                  <div v-if="visibleObservations.length === 0" class="small text-muted">{{ $t('homePage.observationsEmpty') }}</div>
                  <table v-else class="table table-sm observation-table">
                    <thead>
                      <tr>
                        <th>{{ $t('homePage.observationTime') }}</th>
                        <th>{{ $t('homePage.observationSeries') }}</th>
                        <th>{{ $t('homePage.observationAppliance') }}</th>
                        <th>{{ $t('homePage.observationKind') }}</th>
                        <th class="text-end">{{ $t('homePage.observationDelta') }}</th>
                        <th>{{ $t('homePage.observationNote') }}</th>
                        <th v-if="userMayEdit"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="o in visibleObservations" :key="o.id">
                        <td>{{ observationTimeDisplay(o) }}</td>
                        <td>{{ stringForSystemPartAndValueType(o.systempart, o.valuetype) }}</td>
                        <td><template v-if="o.applianceid"><font-awesome-icon :icon="applianceIcon({ icon: o.applianceIcon, category: currentSensor.type })" /> {{ o.applianceName }}</template><span v-else>–</span></td>
                        <td><span class="badge" :class="kindBadgeClass(o.kind)">{{ $t('observationKind.' + o.kind) }}</span></td>
                        <td class="text-end">{{ formatDelta(o.delta, manipulatedUnitDisplay(o.valuetype, '')) }}</td>
                        <td class="observation-note" :title="o.note">{{ o.note }}</td>
                        <td v-if="userMayEdit" class="text-end observation-actions">
                          <font-awesome-icon icon="edit" class="edit-icon" v-title="$t('homePage.editObservation')" @click="openEditObservation(o)" />
                          <font-awesome-icon icon="trash" class="edit-icon" v-title="$t('homePage.deleteObservation')" @click="askDeleteObservation(o)" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="chartViewStatus === 2 && hasSensorAggregations">
                   <column-chart :data="statsDataSets(currentSensor)"  :download="true" />
                </div>
              </div>
            </div>
            <div v-if="sensorHasTotal(currentSensor)" class="sensor-value-content">
              <div class="sensor-item-value"> {{ $t('homePage.headlineSensorTotalSection') }} </div>
              <div class="sensor-item-system"> {{ totalSensorSystemDisplay(currentSensor) }} </div>
              <div class="sensor-item-value"> {{ totalSensorValueDisplay(currentSensor) }} <span class="sensor-item-unit"> {{ totalSensorUnitDisplay(currentSensor) }} </span><span v-if="!sensorHasTotalSinceStart(currentSensor)" class="sensor-item-unit"> ({{ totalSensorAccuracyDisplay(currentSensor) }} % {{ $t('homePage.missingRatioText') }}) </span></div>
              <div class="sensor-item-time"> {{ totalFromNowSensorDisplay(currentSensor) }} </div>
            </div>
            <div v-if="isVirtualSensor(currentSensor)" class="sensor-value-content">
              <div class="sensor-item-system"> {{ sensorSystemDisplay(currentSensor) }} </div>
              <template v-if="dataPackageForSensor(currentSensor)">
                <div class="sensor-item-value"> {{ sensorValueDisplay(currentSensor) }} <span class="sensor-item-unit"> {{ sensorUnitDisplay(currentSensor) }} </span></div>
                <div class="sensor-item-time"> {{ fromNowSensorDisplay(currentSensor) }} </div>
              </template>
              <template v-else>
                <div class="sensor-item-value"> {{ $t('addVirtualSensorValueModal.noData') }} </div>
              </template>
            </div>
            <div v-if="!isVirtualSensor(currentSensor)" class="sensor-value-content">
              <div class="sensor-item-system"> {{ sensorSystemDisplay(currentSensor) }} </div>
              <div class="sensor-item-value"> {{ sensorValueDisplay(currentSensor) }} <span class="sensor-item-unit"> {{ sensorUnitDisplay(currentSensor) }} </span></div>
              <div class="sensor-item-time"> {{ fromNowSensorDisplay(currentSensor) }} </div>
            </div>
            <div v-if="isComputedSensor(currentSensor)" class="sensor-value-content">
              <div class="sensor-item-system"> {{ $t('homePage.computedFormulaLabel') }} </div>
              <div class="sensor-item-formula"> {{ computedFormulaDisplay(currentSensor) }} </div>
            </div>
            <div class="sensor-value-content" v-for="value in nonFirstGlanceValues(currentSensor)" v-bind:key="value">
              <div class="sensor-item-system"> {{ stringForSystemPartAndValueType(value.systempart, value.type) }} </div>
              <div class="sensor-item-value"> {{ formattedValue(value, value.type) }} <span class="sensor-item-unit"> {{ unitDisplay(value) }} </span></div>
              <div v-if="value.valuetime" class="sensor-item-time" :title="valueAsOfTitle(value)"> {{ valueAsOfDisplay(value) }} </div>
              <div v-else class="sensor-item-time"> &nbsp; </div>
              <!--<div class="sensor-item-time"> {{ value.systempart }} {{ value.type }} </div>-->
            </div>
            <div v-if="showApplianceSection" class="sensor-value-content-not-hidden graph-content appliance-section">
              <div class="appliance-head">
                <span class="appliance-title">{{ $t('homePage.appliancesTitle') }}</span>
                <button v-if="userMayEdit" type="button" class="btn btn-primary btn-sm" @click="openAddAppliance(null)"><font-awesome-icon icon="plus" /> &nbsp; {{ $t('homePage.addAppliance') }}</button>
              </div>
              <div v-for="sp in applianceSystemParts" :key="sp" class="appliance-row">
                <span class="appliance-row-label">{{ attributeLabelForCode('systemPart', sp) }}:</span>
                <template v-if="(appliancesBySystempart[sp] || []).length > 0">
                  <span v-for="a in appliancesBySystempart[sp]" :key="a.id" class="badge rounded-pill appliance-badge" :class="{ clickable: userMayEdit }" :title="a.note || a.name" @click="userMayEdit ? openEditAppliance(a) : null">
                    <font-awesome-icon :icon="applianceIcon(a)" /> {{ a.name }}
                  </span>
                </template>
                <span v-else class="small text-muted">{{ $t('homePage.noAppliancesForPoint') }}</span>
              </div>
            </div>
          </div>
          <div class="btn-toolbar meter-reading" v-if="sensorHasTotal(currentSensor)">
            <button type="button" class="btn btn-primary mr-3" @click="manualMeterReading(currentSensor)">
              <font-awesome-icon icon="edit" /> &nbsp; {{ $t('homePage.manualMeterReading') }}
            </button>
          </div>
          <div class="btn-toolbar meter-reading" v-if="isVirtualSensor(currentSensor) && !isComputedSensor(currentSensor)">
            <button type="button" class="btn btn-primary mr-3" @click="openVirtualValueModal()">
              <font-awesome-icon icon="plus" /> &nbsp; {{ $t('addVirtualSensorValueModal.openAddValueButton') }}
            </button>
          </div>
          <div class="btn-toolbar meter-reading" v-if="canSwapMeter(currentSensor)">
            <button type="button" class="btn btn-secondary mr-3" @click="openSwapModalForSensor(currentSensor)">
              <font-awesome-icon icon="history" /> &nbsp; {{ $t('swapSensorModal.openButton') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <page-footer />
    <edit-sensor-total-modal @modalClosed="modalClosed" :selectedSensor="currentSensor" action="add" :modalOpened="modalTimestamp" />
    <add-virtual-sensor-value-modal @modalClosed="modalClosedVirtual" :selectedSensor="currentSensor" :firstGlancePair="firstGlanceSystemPartAndType(currentSensor)" action="add" :modalOpened="virtualModalTimestamp" />
    <sensor-alerts-modal @modalClosed="modalClosed" :title="alertsModalTitle" :items="alertsModalItems" :modalOpened="alertsModalTimestamp" />
    <swap-sensor-modal @modalClosed="modalClosed" @swapped="modalClosedVirtual" :meteringPointId="swapModalMpId" :candidateSensors="swapModalCandidates" :currentSensor="swapModalCurrentSensor" :modalOpened="swapModalTimestamp" />
    <map-snapshot-modal @modalClosed="modalClosed" :selectedOrganization="selectedOrganization" action="add" :selectedFacility="showMapFacility" :modalOpened="modalTimestamp" />
    <edit-facility-modal @modalClosed="modalClosed" :selectedOrganization="editOrganization" :selectedFacility="editFacilityData" action="edit" :modalOpened="editFacilityTimestamp" />
    <edit-device-modal @modalClosed="modalClosed" :selectedFacility="editParentFacility" :selectedCDCDevice="editDeviceData" action="edit" :modalOpened="editDeviceTimestamp" />
    <edit-sensor-modal @modalClosed="modalClosed" :parentFacility="editParentFacility" :parentDevice="editParentDevice" :selectedCDCSensor="editSensorData" action="edit" :modalOpened="editSensorTimestamp" />
    <observation-modal @modalClosed="modalClosedObservation" @createAppliance="createApplianceFromObservation" :currentSensor="currentSensor" :appliances="observationModalAppliances" :proposal="observationProposal" :observation="observationToEdit" :action="observationModalAction" :unit="observationModalUnit" :modalOpened="observationModalTimestamp" />
    <edit-appliance-modal @modalClosed="modalClosedAppliance" @deleteRequested="askDeleteAppliance" :parentFacility="currentFacility" :currentSensor="currentSensor" :sensorPoints="applianceModalPoints" :selectedAppliance="applianceToEdit" :preselectSystempart="applianceModalPreselect" :action="applianceModalAction" :modalOpened="applianceModalTimestamp" />
    <confirm-modal :title="confirmTitle" :text="confirmText" :confirmButtonLabel="$t('confirmModal.confirmButtonLabel')" :cancelButtonLabel="$t('confirmModal.cancelButtonLabel')" @confirm="confirmDeleteAction" @modalClosed="modalClosed" />
  </div>
</template>

<script>
import moment from 'moment'
import objectSorter from '@/utils/object-sorter'
import sendOnChange from '@/utils/send-on-change'
import PageViewMixin from '@/mixins/PageViewMixin.js'
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
import EditSensorTotalModal from '@/modals/EditSensorTotalModal.vue'
import AddVirtualSensorValueModal from '@/modals/AddVirtualSensorValueModal.vue'
import SensorAlertsModal from '@/modals/SensorAlertsModal.vue'
import SwapSensorModal from '@/modals/SwapSensorModal.vue'
import EditFacilityModal from '@/modals/EditFacilityModal.vue'
import EditCDCDeviceModal from '@/modals/EditCDCDeviceModal.vue'
import EditCDCSensorModal from '@/modals/EditCDCSensorModal.vue'
import meteringpointsService from '@/services/meteringpoints'
import cdcdeviceService from '@/services/cdcdevices'
import cdcsensorService from '@/services/cdcsensors'
import { mapGetters } from 'vuex'
import facilityService from '@/services/facilities'
import MapSnapshotModal from '@/modals/MapSnapshotModal.vue'
import DashboardPanel from '@/components/DashboardPanel.vue'
// Health-status rules (staleness, alert reasons, severity mapping) live in
// the shared module so the dashboard status tiles judge with the exact same
// logic — the methods below are thin delegates.
import * as monitoringStatus from '@/utils/monitoring-status'
import * as computedSensors from '@/utils/computed-sensors'
import { AlertReason, sendOnChangeSeen } from '@/utils/monitoring-status'
import ObservationModal from '@/modals/ObservationModal.vue'
import EditApplianceModal from '@/modals/EditApplianceModal.vue'
import ConfirmModal from '@/modals/ConfirmModal.vue'
import appliancesService from '@/services/appliances'
import observationsService from '@/services/observations'
import * as chartObservations from '@/utils/chart-observations'
import * as applianceUtils from '@/utils/appliances'
// import organizationService from '@/services/organizations'

export default {
  name: 'HomePage',
  mixins: [PageViewMixin],
  data () {
    return {
      loaded: false,
      currentFacility: null,
      currentDevice: null,
      currentSensor: { id: -1, name: '' },
      sensorMode: false,
      // Colour stops only — the CSS at the bottom wraps them into
      // a horizontal full-card gradient (classic) or a vertical
      // left-strip gradient (subtle), depending on data-ui-style.
      facilityGradient: 'rgba(251,199,66,1) 0%, rgba(127,232,127,1) 35%, rgba(127,232,127,1) 100%',
      deviceGradient: 'rgba(251,199,66,1) 0%, rgba(127,232,127,1) 35%, rgba(127,232,127,1) 100%',
      showFacilityDetail: false,
      organizationid: 0,
      selectedOrganization: { id: -1, name: '', code: '' },
      currentDetailedFacility: null,
      showMapFacility: {},
      selectedDetailFacility: { id: -1, name: '' },
      pageMode: 'monitoring',
      showScopeReport: false,
      scopeReportType: 'daily',
      mainOnly: true,
      scopeReportLoading: false,
      scopeReportLoaded: false,
      filteredTotals: [],
      meterPlanMonths: 12,
      meterPlanRows: [],
      reportFirstDate: moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),
      reportLastDate: moment(new Date()).format('YYYY-MM-DD'),
      reportFacilityId: '',
      chartDuration: 1,
      statsDuration: 7,
      chartStartDate: moment(new Date()).subtract(1, 'hours').toDate(),
      chartEndDate: new Date(),
      selectedChartDateFromPicker: moment(new Date()).format('YYYY-MM-DD HH:mm'),
      selectedChartDate: new Date(),
      showChartOptions: false,
      chartDataLoading: false,
      statsDataLoading: false,
      chartViewStatus: 1, // 0: no chart, 1: data, 2: stats
      chartDisplayValues: [],
      selectedCharts: [],
      isPreparing: false,
      latestDataPendingSince: null, // in-flight guard for loadLatestCDCDataValues
      cachedData: {},
      // per chart-series metadata for send-on-change sensors: last confirmed
      // point {lastStamp, lastMeasurement} — anchor of the dashed prediction
      cachedMeta: {},
      // Verbraucher + Chart-Beobachtungen (documentation/features/consumers.md)
      appliances: [],
      observations: [],
      observationsLoading: false,
      observationModalTimestamp: '',
      observationModalAction: 'add',
      observationProposal: null,
      observationToEdit: null,
      applianceModalTimestamp: '',
      applianceModalAction: 'add',
      applianceToEdit: null,
      applianceModalPoints: [],
      applianceModalPreselect: null,
      pendingObservationProposal: null,
      pendingDelete: null,
      virtualModalTimestamp: '',
      alertsModalTimestamp: '',
      alertsModalTitle: '',
      alertsModalItems: [],
      swapModalTimestamp: '',
      swapModalMpId: null,
      swapModalCandidates: [],
      swapModalCurrentSensor: null,
      // edit pencils in the monitoring view: the modals must receive the
      // FULL objects from the admin endpoints — the latestdata tree lacks
      // required fields (see openEditFacility/Device/Sensor)
      editFacilityData: { id: -1, organizationid: -1, name: '' },
      editFacilityTimestamp: '',
      editDeviceData: { id: -1, facilityid: -1, apikey: '', serialnumber: '' },
      editDeviceTimestamp: '',
      editSensorData: null,
      editSensorTimestamp: '',
      editParentFacility: { id: -1, organizationid: -1, name: '' },
      editParentDevice: { id: -1, facilityid: -1, apikey: '', serialnumber: '' }
    }
  },
  computed: {
    ...mapGetters([
      'client',
      'organizations',
      'hasOrganizations',
      'cdcdatavalues',
      'hasCdcdatavalues',
      'facilities',
      'company',
      'sensorAggregations',
      'hasSensorAggregations',
      'sensorTotalScope',
      'meterPlan'
    ]),
    // rows of whichever report is active — drives the entry count and the download button
    reportEntryCount () {
      return this.scopeReportType === 'meterplan' ? this.meterPlanRows.length : this.filteredTotals.length
    },
    // flat column list of the meter plan: a reading column per date and a consumption
    // column between two dates (no <template v-for>: the Vue 3 compiler and the project's
    // lint rule disagree on where its key belongs)
    meterPlanColumns () {
      const dates = this.meterPlan && this.meterPlan.dates ? this.meterPlan.dates : []
      const columns = []
      dates.forEach((date, i) => {
        columns.push({ key: 'r' + date, kind: 'reading', index: i, date })
        if (i < dates.length - 1) columns.push({ key: 'c' + date, kind: 'delta', index: i, date })
      })
      return columns
    },
    // true while a latestdata request is on its way. Shown next to isLoading
    // because PageViewMixin clears isLoading whenever the global `running`
    // flag drops — and every fast response (company, client, facility list)
    // does that long before the slow latestdata answer arrives.
    latestDataPending () {
      return this.latestDataPendingSince != null
    },
    facilitiesLocal () {
      const organization = this.hasOrganizations ? this.organizations[0] : null
      // `facilities` may be missing when another view's store action put the
      // admin organization list here — never let the render throw on it.
      return organization != null && Array.isArray(organization.facilities) ? organization.facilities : []
    },
    // organization object for EditFacilityModal (needs a name — the
    // client.organization entry only guarantees id/code)
    editOrganization () {
      const organization = this.hasOrganizations ? this.organizations[0] : null
      return organization != null ? organization : { id: -1, name: '', code: '' }
    },
    // Same set as facilitiesLocal but sorted by combined alert severity:
    // worst-first, then more-reasons-first, then by name for a stable order.
    // Used by the monitoring view; the report-selector keeps facilitiesLocal
    // so the dropdown stays alphabetical-by-source.
    facilitiesSortedByAlerts () {
      const list = this.facilitiesLocal.slice()
      list.sort((a, b) => {
        const aSev = this.facilitySeverityForSort(a)
        const bSev = this.facilitySeverityForSort(b)
        if (aSev !== bSev) return bSev - aSev
        const aCount = this.facilityAlertReasons(a).reasons.length
        const bCount = this.facilityAlertReasons(b).reasons.length
        if (aCount !== bCount) return bCount - aCount
        return (a.name || '').localeCompare(b.name || '')
      })
      return list
    },
    // ---- Verbraucher + Chart-Beobachtungen ----------------------------
    currentFacilityId () {
      return this.currentFacility ? this.currentFacility.id : null
    },
    observationIndex () {
      return chartObservations.indexByLabel(this.observations)
    },
    visibleObservations () {
      return chartObservations.sortByTime(this.observations.filter(o => chartObservations.inWindow(o, this.chartStartDate, this.chartEndDate)))
    },
    // click-to-annotate only on the line chart (gas/water impulse bars have no on/off semantics)
    supportsChartClick () {
      return !!this.currentSensor && this.currentSensor.id >= 0 && this.currentSensor.type !== 1 && this.currentSensor.type !== 2
    },
    showApplianceSection () {
      const s = this.currentSensor
      return !!s && s.id >= 0 && !this.isVirtualSensor(s) && s.type >= 0 && s.type <= 3
    },
    // every systempart the sensor shows a tile for, plus those of already
    // attached appliances — the checkbox list of the appliance modal
    applianceTileSystemParts () {
      if (!this.showApplianceSection) return []
      const pair = this.effectiveFirstGlancePair(this.currentSensor)
      const tiles = (pair ? [pair] : []).concat(this.nonFirstGlanceValues(this.currentSensor).map(v => ({ systempart: v.systempart, valuetype: v.type })))
      return applianceUtils.systemPartsForSensor(tiles, this.appliances, this.currentSensor.id)
    },
    // rows of the appliance section: phases / total (systempart 0..4) and
    // every systempart that already carries an appliance — a Kostal has a
    // dozen further tiles (day totals, battery, ...) that would only add noise
    applianceSystemParts () {
      const attached = applianceUtils.systemPartsForSensor([], this.appliances, this.currentSensor ? this.currentSensor.id : null)
      return this.applianceTileSystemParts.filter(sp => sp <= 4 || attached.includes(sp))
    },
    appliancesBySystempart () {
      return applianceUtils.groupAppliancesBySystempart(this.appliances, this.currentSensor ? this.currentSensor.id : null)
    },
    // picker of the observation modal: appliances attached to the clicked
    // point first, then the rest of the same category (annotating a phase the
    // appliance is not attached to is allowed)
    observationModalAppliances () {
      const source = this.observationProposal || this.observationToEdit
      const sp = source ? source.systempart : null
      const all = this.appliances.filter(a => a.category === this.currentSensor.type)
      if (sp == null) return all
      const attached = applianceUtils.appliancesForPoint(all, this.currentSensor.id, sp)
      return attached.concat(all.filter(a => !attached.includes(a)))
    },
    observationModalUnit () {
      const source = this.observationProposal || this.observationToEdit
      return source && source.valuetype != null ? this.manipulatedUnitDisplay(source.valuetype, '') : ''
    },
    confirmTitle () {
      if (!this.pendingDelete) return ''
      return this.pendingDelete.type === 'appliance' ? this.$t('homePage.confirmDeleteApplianceTitle') : this.$t('homePage.confirmDeleteObservationTitle')
    },
    confirmText () {
      if (!this.pendingDelete) return ''
      return this.pendingDelete.type === 'appliance'
        ? this.$t('homePage.confirmDeleteApplianceText', { name: this.pendingDelete.name })
        : this.$t('homePage.confirmDeleteObservationText')
    },
    cdcDataSortedByTime () {
      if (!this.hasCdcdatavalues) {
        return []
      }
      // Sort (and later plot) on the measurement time, not the ingestion time:
      // a batched packet — CS-* v5 sensors send up to five measurements taken a
      // minute apart in ONE transmission — shares a single recordedtime, so
      // sorting and keying on it made four of the five values collapse onto the
      // same chart point. See effectiveTime().
      const withEffectiveTime = this.cdcdatavalues.map(dataPackage => ({
        ...dataPackage,
        effectivetime: this.effectiveTime(dataPackage)
      }))
      return objectSorter.sortedArray(withEffectiveTime, 'asc', 'effectivetime')
    },
    emptyFacility () {
      return {
        id: -1,
        organizationid: this.selectedOrganization.id,
        name: '',
        description: '',
        geolatitude: null,
        geolongitude: null
      }
    }
  },
  created () {
    // this.loadLatestCDCDataValues()
    this.timer = setInterval(this.loadLatestCDCDataValues, 60 * 1000) // alle 60 Sekunden
    moment.updateLocale('de', {
      relativeTime: {
        future: 'in %s',
        past: 'vor %s',
        s: 'einigen Sekunden',
        ss: '%d Sekunden',
        m: 'einer Minute',
        mm: '%d Minuten',
        h: 'einer Stunde',
        hh: '%d Stunden',
        d: 'einem Tag',
        dd: '%d Tagen',
        w: 'einer Woche',
        ww: '%d Wochen',
        M: 'einem Monat',
        MM: '%d Monaten',
        y: 'einem Jahr',
        yy: '%d Jahren'
      }
    })
  },
  unmounted () {
    this.$store.dispatch('discardLatestSensorData')
    this.$store.dispatch('discardCDCDataValuesSlim')
    this.$store.dispatch('discardDailyTotals')
    this.$store.dispatch('discardSensorAggregations')
    this.chartDuration = 1
    this.statsDuration = 7
    clearInterval(this.timer)
  },
  mounted () {
    this.clearError()
    if (this.client.organization.id > 0) {
      this.loadLatestCDCDataValues()
    }

    if (this.company != null && (this.company.brand === 'chl' || this.company.name === 'Clever Home Labs')) {
      this.showFacilityDetail = true
    }
    if (this.client.organization.id > 0) {
      this.organizationid = this.client.organization.id
      this.selectedOrganization = { id: this.client.organization.id, name: '', code: '' }
      this.loadDetailedFacilities(true)
    }
  },
  components: {
    'page-header': PageHeader,
    'page-footer': PageFooter,
    'edit-sensor-total-modal': EditSensorTotalModal,
    'add-virtual-sensor-value-modal': AddVirtualSensorValueModal,
    'sensor-alerts-modal': SensorAlertsModal,
    'swap-sensor-modal': SwapSensorModal,
    'map-snapshot-modal': MapSnapshotModal,
    'edit-facility-modal': EditFacilityModal,
    'edit-device-modal': EditCDCDeviceModal,
    'edit-sensor-modal': EditCDCSensorModal,
    'dashboard-panel': DashboardPanel,
    'observation-modal': ObservationModal,
    'edit-appliance-modal': EditApplianceModal,
    'confirm-modal': ConfirmModal
  },
  watch: {
    client () {
      if (this.client.organization.id > 0) {
        this.cachedData = {}
        this.cachedMeta = {}
        this.loadLatestCDCDataValues()
        // also load the facility details seem on mount is to early
        if (this.company != null && (this.company.brand === 'chl' || this.company.name === 'Clever Home Labs')) {
          this.showFacilityDetail = true
        }
        this.organizationid = this.client.organization.id
        this.selectedOrganization = { id: this.client.organization.id, name: '', code: '' }
        this.loadDetailedFacilities(true)
      }
    },
    // the 60 s refresh replaces the facility OBJECT — watch the id, not the object
    currentFacilityId () {
      this.appliances = []
      this.loadAppliances()
    },
    chartDisplayValues () {
      // this.setChartDates()
      // this.loadDataValues()
    },
    cdcdatavalues () {
      this.cachedData = {}
      this.cachedMeta = {}
      this.chartDataLoading = false
      this.isLoading = false
      this.chartDisplayValues = this.avalableValuetypes()
      this.setChartDates()
    },
    facilities () {
      // the facility list (maps/pickers) is not what the spinner waits for —
      // it used to clear isLoading here, which hid "loading…" while the slow
      // latestdata request was still running
    },
    organizations () {
      // the latestdata tree arrived (or was replaced) — the spinner and the
      // in-flight guard belong to that request, not to the facility list
      this.isLoading = false
      this.latestDataPendingSince = null
    },
    errorflag (flag) {
      // a failed latestdata request must release the guard and the spinner
      if (flag && this.errorinfo && this.errorinfo.origin === 'getLatestCDCDataValues') {
        this.latestDataPendingSince = null
      }
    },
    sensorTotalScope () {
      this.scopeReportLoading = false
      this.scopeReportLoaded = true
      this.applyTotalsFilter()
    },
    meterPlan () {
      this.scopeReportLoading = false
      this.scopeReportLoaded = true
      this.meterPlanRows = this.sortedMeterPlanRows()
    },
    mainOnly () {
      this.applyTotalsFilter()
    },
    currentSensor (newSensor, oldSensor) {
      // Only a real selection change may reset the chart view. The 60 s
      // auto-refresh commits a completely new organization tree
      // (updateOrganizationData replaces state.organizations), and
      // loadLatestCDCDataValues() then re-points currentSensor at the fresh
      // object for the *same* sensor — which used to land here and throw away
      // the day view (chartDuration back to 1, so the measurement dots
      // reappeared), the selected date and the selected series every minute.
      // The cache and chartDisplayValues are refreshed by the cdcdatavalues
      // watcher when the new chart data arrives, so nothing is lost by
      // returning early.
      if (oldSensor && newSensor && oldSensor.id === newSensor.id) {
        return
      }
      this.cachedData = {}
      this.cachedMeta = {}
      this.observations = []
      this.selectedChartDate = new Date()
      this.chartDuration = 1
      this.chartStartDate = moment(this.selectedChartDate).subtract(this.chartDuration, 'hours').toDate()
      this.chartEndDate = moment(this.selectedChartDate).toDate()
      if (this.currentSensor.id > -1) {
        this.loadWeeklyAggregations()
      }
      const pair = this.firstGlanceSystemPartAndType(this.currentSensor)
      this.selectedCharts = [{ text: this.stringForSystemPartAndValueType(pair.systempart, pair.valuetype), value: pair }]
      this.chartDisplayValues = this.avalableValuetypes()
    },
    sensorAggregations () {
      this.statsDataLoading = false
    },
    reportFirstDate () {
      this.$store.commit('discardSensorTotalScope')
    },
    reportLastDate () {
      this.$store.commit('discardSensorTotalScope')
    },
    chartDuration () {
      // Reformat picker value when switching between hour (with time) and day (date only) mode
      this.selectedChartDateFromPicker = this.chartDuration === 1
        ? moment(this.selectedChartDate).format('YYYY-MM-DD HH:mm')
        : moment(this.selectedChartDate).format('YYYY-MM-DD')
      this.setChartDates()
      this.loadDataValues()
    },
    statsDuration () {
      // reload chart data
      this.setChartDates()
      this.loadWeeklyAggregations()
    },
    selectedChartDateFromPicker () {
      if (this.selectedChartDateFromPicker === null) {
        // if you press the x on the picker it sets the date to null
        this.selectedChartDateFromPicker = this.chartDuration === 1
          ? moment(new Date()).format('YYYY-MM-DD HH:mm')
          : moment(new Date()).format('YYYY-MM-DD')
        return
      }
      const fmt = this.chartDuration === 1 ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
      if (this.selectedChartDateFromPicker !== moment(this.selectedChartDate).format(fmt)) {
        this.selectedChartDate = new Date(this.selectedChartDateFromPicker)
      }
    },
    selectedChartDate () {
      const fmt = this.chartDuration === 1 ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
      this.selectedChartDateFromPicker = moment(this.selectedChartDate).format(fmt)
      this.setChartDates()
      this.loadDataValues()
      this.loadWeeklyAggregations()
    },
    isPreparing () {
      this.$forceUpdate()
    }
  },
  methods: {
    formatedChartDate () {
      const options = this.chartDuration === 1
        ? { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }
        : { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      if (this.selectedChartDate != null) {
        return this.selectedChartDate.toLocaleString('de-DE', options)
      }
      return ''
    },
    setChartDates () {
      if (this.chartDuration === 1) {
        // var now = new Date()
        const selected = new Date(this.selectedChartDate)
        // just set the hour window to the current time
        // selected.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0)
        this.chartStartDate = moment(selected).subtract(this.chartDuration, 'hours').toDate()
        this.chartEndDate = moment(selected).toDate()
      } else {
        const start = new Date(this.selectedChartDate)
        start.setHours(0, 0, 0, 0)
        this.chartStartDate = start
        const end = new Date(this.selectedChartDate)
        end.setHours(23, 59, 59, 999)
        this.chartEndDate = end
      }
    },
    valueWithFactor (value, factor) {
      if (value) {
        return parseFloat(value).toLocaleString(navigator.language)
        // return parseFloat(value * Math.pow(10, factor)).toLocaleString(navigator.language)
      }
      return 0.0
    },
    valueWithFactorShortened (value, factor, unit) {
      /* eslint-disable no-console */
      console.log(value + ' ' + factor + ' ' + unit)
      if (value) {
        if (unit && unit === 'Wh') {
          return (parseFloat(value) > 100000 ? Math.round(parseFloat(value) / 1000) : parseFloat(value)).toLocaleString(navigator.language)
        } else {
          return parseFloat(value).toLocaleString(navigator.language)
        }
        // return parseFloat(value * Math.pow(10, factor)).toLocaleString(navigator.language)
      }
      return 0.0
    },
    unitWithFactorShortened (value, factor, unit) {
      if (value && unit === 'Wh') {
        return parseFloat(value) > 100000 ? 'k' + unit : unit
        // return parseFloat(value * Math.pow(10, factor)).toLocaleString(navigator.language)
      }
      return unit
    },
    createChartDataTSV () {
      if (this.selectedCharts && this.selectedCharts.length > 0) {
        let header = 'Uhrzeit\t'
        this.selectedCharts.forEach(chartSet => {
          const title = this.stringForSystemPartAndValueType(chartSet.value.systempart, chartSet.value.valuetype) // + ' ' + this.manipulatedUnitDisplay(chartSet.value.valuetype, '')
          header += title + '\t\t'
        })
        header += '\n'
        let tsv = ''
        // union of the keys of ALL selected series, chronologically sorted —
        // series can differ in density (e.g. send-on-change backfill), so a
        // key may be missing in one of them
        const allSeries = this.selectedCharts.map(chartSet =>
          this.currentData(this.currentSensor, chartSet.value.systempart, chartSet.value.valuetype))
        const allKeys = sendOnChange.unionSortedKeys(allSeries)
        for (const key of allKeys) {
          tsv += key + '\t'
          this.selectedCharts.forEach(chartSet => {
            const data = this.currentData(this.currentSensor, chartSet.value.systempart, chartSet.value.valuetype)
            const cell = data[key]
            tsv += (cell != null ? cell.toLocaleString(navigator.language) : '') + '\t'
            tsv += this.manipulatedUnitDisplay(chartSet.value.valuetype, '') + '\t'
          })
          tsv += '\n'
        }
        return header + tsv
      }
    },
    createDayStatsDataTSV () {
      let header = 'Datum\t'
      if (this.sensorAggregations.aggregations && this.sensorAggregations.aggregations.length > 0) {
        const dataPackage = this.sensorAggregations.aggregations[0]
        header += 'Zählerstand ' + this.stringForSystemPartAndValueType(dataPackage.frstimpsp, dataPackage.frstimpvt) + '\t'
        header += '\t'
        header += 'Tag ' + this.stringForSystemPartAndValueType(dataPackage.dailyimpsp, dataPackage.dailyimpvt) + '\t'
        header += '\t'
        header += 'Zählerstand ' + this.stringForSystemPartAndValueType(dataPackage.frstexpsp, dataPackage.frstexpvt) + '\t'
        header += '\t'
        header += 'Tag ' + this.stringForSystemPartAndValueType(dataPackage.dailyexpsp, dataPackage.dailyexpvt) + '\t'
        header += '\t'
        header += this.stringForSystemPartAndValueType(dataPackage.systempart, dataPackage.valuetype) + ' Min. ' + '\t'
        header += '\t'
        header += this.stringForSystemPartAndValueType(dataPackage.systempart, dataPackage.valuetype) + ' Max. ' + '\t'
        header += '\t'
        header += this.stringForSystemPartAndValueType(dataPackage.systempart, dataPackage.valuetype) + ' Mittel x̄ ' + '\t'
        header += '\t'
        header += 'CO2e\t'
        header += '\n'
      } else {
        header += 'Zählerstand-Import\tTagesimport\tZählerstand-Export\tTagesexport\tmin\tmax\tavg\tCO2e\n'
      }
      let tsv = ''
      if (this.sensorAggregations.aggregations) {
        this.sensorAggregations.aggregations.forEach(dataPackage => {
          const stamp = moment(String(dataPackage.date))
          tsv += stamp.format('L') + '\t'
          if (dataPackage.frstimp) {
            tsv += dataPackage.frstimp.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.frstimpvt, '') + '\t'
          } else { tsv += '\t\t' }
          if (dataPackage.dailyimp) {
            tsv += dataPackage.dailyimp.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.dailyimpvt, '') + '\t'
          } else { tsv += '\t\t' }
          if (dataPackage.frstexp) {
            tsv += dataPackage.frstexp.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.frstexpvt, '') + '\t'
          } else { tsv += '\t\t' }
          if (dataPackage.dailyexp) {
            tsv += dataPackage.dailyexp.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.dailyexpvt, '') + '\t'
          } else { tsv += '\t\t' }
          if (dataPackage.min) {
            tsv += dataPackage.min.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.valuetype, '') + '\t'
          } else { tsv += '\t\t' }
          if (dataPackage.max) {
            tsv += dataPackage.max.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.valuetype, '') + '\t'
          } else { tsv += '\t\t' }
          if (dataPackage.cnt > 0) {
            const avg = dataPackage.sum / dataPackage.cnt
            tsv += avg.toLocaleString(navigator.language) + '\t'
            tsv += this.manipulatedUnitDisplay(dataPackage.valuetype, '') + '\t'
          } else {
            tsv += '\t\t'
          }
          if (dataPackage.co2e) {
            tsv += dataPackage.co2e.toLocaleString(navigator.language) + '\tkg\n'
          } else {
            tsv += '\t\n'
          }
        })
        return header + tsv
      }
    },
    downloadTSVChartData () {
      this.isPreparing = true
      this.prepareTSVChartData()
    },
    prepareTSVChartData () {
      const anchor = document.createElement('a')
      anchor.href = 'data:text/tsv;charset=utf-8,' + encodeURIComponent(this.createChartDataTSV())
      anchor.target = '_blank'
      anchor.download = this.formatDateForFilename(this.selectedChartDate) + '_' + this.$t('homePage.chartData') + '_' + this.client.organization.code + '_' + this.currentSensor.name + '.tsv'
      anchor.click()
      this.isPreparing = false
    },
    downloadTSVDayStatsData () {
      this.isPreparing = true
      const anchor = document.createElement('a')
      anchor.href = 'data:text/tsv;charset=utf-8,' + encodeURIComponent(this.createDayStatsDataTSV())
      anchor.target = '_blank'
      anchor.download = this.formatDateForFilename(this.selectedChartDate) + '_' + this.$t('homePage.dayStatsData') + '_' + this.client.organization.code + '_' + this.currentSensor.name + '.tsv'
      anchor.click()
      this.isPreparing = false
    },
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
      }
    },
    formatDateTime (value) {
      if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm')
      }
    },
    formatDateForFilename (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    openScopeReport (type) {
      this.scopeReportType = type
      this.pageMode = 'reports'
      if (this.reportFacilityId === '' && this.facilitiesLocal.length > 0) {
        this.reportFacilityId = this.facilitiesLocal[0].id
      }
    },
    applyTotalsFilter () {
      if (!this.sensorTotalScope.totals) {
        this.filteredTotals = []
        return
      }
      const totals = this.mainOnly
        ? this.sensorTotalScope.totals.filter(t => t.main)
        : [...this.sensorTotalScope.totals]
      this.filteredTotals = totals.sort((a, b) => a.cdcsensorid - b.cdcsensorid)
    },
    loadScopeReport () {
      if (!this.reportFacilityId) return
      this.clearError()
      this.scopeReportLoading = true
      this.scopeReportLoaded = false
      this.$store.commit('clearError')
      if (this.scopeReportType === 'meterplan') {
        this.meterPlanRows = []
        this.$store.dispatch('getMeterPlan', {
          facilityId: this.reportFacilityId,
          lastDateString: this.reportLastDate,
          months: this.meterPlanMonths
        })
        return
      }
      const payload = {
        facilityId: this.reportFacilityId,
        firstDateString: this.scopeReportType === 'daily' ? this.reportLastDate : this.reportFirstDate,
        lastDateString: this.reportLastDate,
        reportType: this.scopeReportType
      }
      this.$store.dispatch('getSensorTotalScope', payload)
    },
    dateOutOfScope (dateValue, referenceDateString) {
      if (!dateValue || !referenceDateString) return false
      return moment(String(dateValue)).format('YYYY-MM-DD') !== referenceDateString
    },
    scopeDataIncomplete (total) {
      if (this.scopeReportType === 'daily') {
        return this.dateOutOfScope(total.enddate, this.reportLastDate)
      }
      return this.dateOutOfScope(total.startdate, this.reportFirstDate) || this.dateOutOfScope(total.enddate, this.reportLastDate)
    },
    whToKwh (value, unit) {
      if (value == null) return null
      if (unit === 'Wh') {
        return Math.round(value / 1000)
      }
      if (unit === 'm3' || unit === 'm³') {
        return Math.round(value)
      }
      return value
    },
    normalizeUnit (unit) {
      return unit === 'Wh' ? 'kWh' : unit
    },
    formatCost (cost) {
      if (cost == null) return ''
      return Number(cost).toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
    },
    createCO2ReportTSV () {
      if (!this.filteredTotals.length) return ''
      let tsv = 'Typ\tHauptzähler\tSensor\tZähler Info\tExt. Sensor Id\tMarktlokation\tObjekt\tVon\tBis\tCO2e (kg)\tScope\n'
      this.filteredTotals.forEach(total => {
        tsv += this.sensorTypeLocalized(total.type) + '\t'
        tsv += (total.main ? 'Ja' : 'Nein') + '\t'
        tsv += (total.sensorName || '') + '\t'
        tsv += (total.meterinfo || '') + '\t'
        tsv += (total.externalsensorid || '') + '\t'
        tsv += (total.maloid || '') + '\t'
        tsv += (total.facilityName || '') + '\t'
        tsv += this.formatDate(total.startdate) + '\t'
        tsv += this.formatDate(total.enddate) + '\t'
        tsv += (total.co2e != null ? total.co2e.toLocaleString(navigator.language) : '') + '\t'
        tsv += (total.scope != null ? total.scope : '') + '\n'
      })
      return tsv
    },
    createUsageReportTSV () {
      if (!this.filteredTotals.length) return ''
      let tsv = 'Typ\tHauptzähler\tSensor\tZähler Info\tExt. Sensor Id\tMarktlokation\tObjekt\tVon\tBis\tVerbrauch\tEinheit\tKosten (€)\n'
      this.filteredTotals.forEach(total => {
        tsv += this.sensorTypeLocalized(total.type) + '\t'
        tsv += (total.main ? 'Ja' : 'Nein') + '\t'
        tsv += (total.sensorName || '') + '\t'
        tsv += (total.meterinfo || '') + '\t'
        tsv += (total.externalsensorid || '') + '\t'
        tsv += (total.maloid || '') + '\t'
        tsv += (total.facilityName || '') + '\t'
        tsv += this.formatDate(total.startdate) + '\t'
        tsv += this.formatDate(total.enddate) + '\t'
        tsv += (total.total != null ? this.whToKwh(total.total, total.unit).toLocaleString(navigator.language) : '') + '\t'
        tsv += this.normalizeUnit(total.unit || '') + '\t'
        tsv += (total.cost != null ? total.cost.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '') + '\n'
      })
      return tsv
    },
    createDailyReportTSV () {
      if (!this.filteredTotals.length) return ''
      let tsv = 'Typ\tHauptzähler\tSensor\tZähler Info\tExt. Sensor Id\tMarktlokation\tObjekt\tDatum\tZählerstand\tEinheit\tOBIS\n'
      this.filteredTotals.forEach(total => {
        tsv += this.sensorTypeLocalized(total.type) + '\t'
        tsv += (total.main ? 'Ja' : 'Nein') + '\t'
        tsv += (total.sensorName || '') + '\t'
        tsv += (total.meterinfo || '') + '\t'
        tsv += (total.externalsensorid || '') + '\t'
        tsv += (total.maloid || '') + '\t'
        tsv += (total.facilityName || '') + '\t'
        tsv += this.formatDate(total.enddate) + '\t'
        tsv += (total.endvalue != null ? this.whToKwh(total.endvalue, total.unit).toLocaleString(navigator.language) : '') + '\t'
        tsv += this.normalizeUnit(total.unit || '') + '\t'
        tsv += (total.obis || '') + '\n'
      })
      return tsv
    },
    // ---- meter plan (Zählerübersicht) -------------------------------------------------
    sortedMeterPlanRows () {
      const rows = this.meterPlan && this.meterPlan.rows ? [...this.meterPlan.rows] : []
      // by the customer's meter key (apu) when maintained, otherwise by name
      return rows.sort((a, b) => {
        const apuA = a.meta && a.meta.apu != null ? Number(a.meta.apu) : null
        const apuB = b.meta && b.meta.apu != null ? Number(b.meta.apu) : null
        if (apuA !== null && apuB !== null && apuA !== apuB) return apuA - apuB
        if (apuA !== null && apuB === null) return -1
        if (apuA === null && apuB !== null) return 1
        return String(a.sensorName || '').localeCompare(String(b.sensorName || ''))
      })
    },
    // reading in the display unit (kWh / m³), like the daily report
    meterPlanValue (row, reading) {
      if (!reading || reading.value == null) return null
      return this.whToKwh(reading.value, row.unit)
    },
    // consumption between column i and the next older column i + 1 (dates are newest first)
    meterPlanDelta (row, i) {
      const current = this.meterPlanValue(row, row.readings[i])
      const older = i + 1 < row.readings.length ? this.meterPlanValue(row, row.readings[i + 1]) : null
      if (current === null || older === null) return null
      return current - older
    },
    meterPlanCellText (row, col) {
      if (col.kind === 'delta') {
        const delta = this.meterPlanDelta(row, col.index)
        return delta !== null ? this.$formatNumber(delta, 0) : ''
      }
      const value = this.meterPlanValue(row, row.readings[col.index])
      return value !== null ? this.$formatNumber(value, 0) : '-'
    },
    meterPlanReadingOffDay (row, col) {
      const reading = col.kind === 'reading' ? row.readings[col.index] : null
      return !!(reading && reading.actualDate && reading.actualDate !== reading.date)
    },
    meterPlanCellStyle (row, col) {
      return this.meterPlanReadingOffDay(row, col) ? 'color: orange; text-align: right;' : 'text-align: right;'
    },
    meterPlanCellTitle (row, col) {
      return this.meterPlanReadingOffDay(row, col) ? this.formatDate(row.readings[col.index].actualDate) : ''
    },
    levelLabel (bl) {
      if (bl === null || bl === undefined || bl === '') return ''
      const level = Number(bl)
      if (Number.isNaN(level)) return String(bl)
      return level === 0 ? this.$t('homePage.groundFloor') : level + '. ' + this.$t('homePage.upperFloor')
    },
    createMeterPlanTSV () {
      if (!this.meterPlanRows.length) return ''
      const dates = this.meterPlan.dates || []
      const header = [this.$t('homePage.meterNumber'), this.$t('homePage.apu'), this.$t('homePage.sensorName'), this.$t('homePage.serialNumber'),
        this.$t('homePage.apartment'), this.$t('homePage.houseNumber'), this.$t('homePage.level'), this.$t('homePage.position'),
        this.$t('homePage.unit')]
      dates.forEach((date, i) => {
        header.push(this.$t('homePage.reading') + ' ' + this.formatDate(date))
        header.push(this.$t('homePage.readingDate'))
        if (i < dates.length - 1) header.push(this.$t('homePage.consumption'))
      })
      let tsv = header.join('\t') + '\n'
      this.meterPlanRows.forEach(row => {
        const meta = row.meta || {}
        const cells = [row.meterinfo || '', meta.apu != null ? meta.apu : '', row.sensorName || '', row.serialnr || '',
          meta.whg || '', meta.be != null ? meta.be : '', this.levelLabel(meta.bl), (meta.oid || '') + (meta.loc ? ' (' + meta.loc + ')' : ''),
          this.normalizeUnit(row.unit || '')]
        row.readings.forEach((reading, i) => {
          const value = this.meterPlanValue(row, reading)
          cells.push(value !== null ? value.toLocaleString(navigator.language) : '')
          cells.push(reading.actualDate ? this.formatDate(reading.actualDate) : '')
          if (i < row.readings.length - 1) {
            const delta = this.meterPlanDelta(row, i)
            cells.push(delta !== null ? delta.toLocaleString(navigator.language) : '')
          }
        })
        tsv += cells.join('\t') + '\n'
      })
      return tsv
    },
    downloadScopeReportTSV () {
      this.isPreparing = true
      let content, label, filename
      if (this.scopeReportType === 'meterplan') {
        content = this.createMeterPlanTSV()
        label = this.$t('homePage.meterPlan')
        filename = this.reportLastDate + '_' + label + '_' + this.client.organization.code + '.tsv'
      } else if (this.scopeReportType === 'co2') {
        content = this.createCO2ReportTSV()
        label = this.$t('homePage.co2Report')
        filename = this.reportFirstDate + '_' + this.reportLastDate + '_' + label + '_' + this.client.organization.code + '.tsv'
      } else if (this.scopeReportType === 'usage') {
        content = this.createUsageReportTSV()
        label = this.$t('homePage.usageReport')
        filename = this.reportFirstDate + '_' + this.reportLastDate + '_' + label + '_' + this.client.organization.code + '.tsv'
      } else {
        content = this.createDailyReportTSV()
        label = this.$t('homePage.dailyTotals')
        filename = this.reportFirstDate + '_' + label + '_' + this.client.organization.code + '.tsv'
      }
      const anchor = document.createElement('a')
      anchor.href = 'data:text/tsv;charset=utf-8,' + encodeURIComponent(content)
      anchor.target = '_blank'
      anchor.download = filename
      anchor.click()
      this.isPreparing = false
    },
    emissionTypeLabel (type) {
      const labels = { 0: 'Strom', 1: 'Gas', 2: 'Wasser', 3: 'Wärme' }
      return labels[type] || type
    },
    emissionTypeUnit (type) {
      return type === 2 ? 'm³' : 'kWh'
    },
    async printScopeReport () {
      if (!this.filteredTotals.length) return
      // Strict compare is safe here: the select binds :value="facility.id", so
      // v-model keeps the numeric id rather than a string.
      const facility = this.facilitiesLocal.find(f => f.id === this.reportFacilityId) || {}
      const orgName = this.client.organization ? this.client.organization.name : ''
      const printDate = new Date().toLocaleDateString(navigator.language)
      const userName = [this.client.firstname, this.client.lastname].filter(Boolean).join(' ') || this.client.name || ''

      let emissions = []
      try {
        const data = await facilityService.getEmissions(this.reportFacilityId)
        emissions = (data.emissions || []).filter(e => e.active)
      } catch (_) { /* skip if unavailable */ }

      const allTotals = this.sensorTotalScope.totals
        ? [...this.sensorTotalScope.totals].sort((a, b) => a.cdcsensorid - b.cdcsensorid)
        : []
      const mainTotals = allTotals.filter(t => t.main)
      const subTotals = allTotals.filter(t => !t.main)
      const showBothGroups = !this.mainOnly && subTotals.length > 0

      const buildRow = (total, bgStyle) => {
        const trStyle = bgStyle ? ` style="${bgStyle}"` : ''
        if (this.scopeReportType === 'co2') {
          return `<tr${trStyle}>
            <td>${total.sensorName || ''}</td>
            <td>${total.meterinfo || ''}</td>
            <td>${total.externalsensorid || ''}</td>
            <td>${total.maloid || ''}</td>
            <td>${total.facilityName || ''}</td>
            <td>${this.formatDate(total.startdate) || ''}</td>
            <td>${this.formatDate(total.enddate) || ''}</td>
            <td style="text-align:right">${this.$formatNumber(total.co2e, 3)}</td>
            <td>${total.scope != null ? total.scope : ''}</td>
          </tr>`
        } else if (this.scopeReportType === 'usage') {
          return `<tr${trStyle}>
            <td>${total.sensorName || ''}</td>
            <td>${total.meterinfo || ''}</td>
            <td>${total.externalsensorid || ''}</td>
            <td>${total.maloid || ''}</td>
            <td>${total.facilityName || ''}</td>
            <td>${this.formatDate(total.startdate) || ''}</td>
            <td>${this.formatDate(total.enddate) || ''}</td>
            <td style="text-align:right">${this.$formatNumber(this.whToKwh(total.total, total.unit), 0)}</td>
            <td>${this.normalizeUnit(total.unit || '')}</td>
            <td style="text-align:right">${this.formatCost(total.cost)}</td>
          </tr>`
        } else {
          return `<tr${trStyle}>
            <td>${total.sensorName || ''}</td>
            <td>${total.meterinfo || ''}</td>
            <td>${total.externalsensorid || ''}</td>
            <td>${total.maloid || ''}</td>
            <td>${total.facilityName || ''}</td>
            <td>${this.formatDate(total.enddate) || ''}</td>
            <td style="text-align:right">${this.$formatNumber(this.whToKwh(total.endvalue, total.unit), 0)}</td>
            <td>${this.normalizeUnit(total.unit || '')}</td>
            <td>${total.obis || ''}</td>
          </tr>`
        }
      }

      const thead = this.scopeReportType === 'co2'
        ? '<th>Sensor</th><th>Zähler Info</th><th>Ext. Sensor Id</th><th>Marktlokation</th><th>Objekt</th><th>Von</th><th>Bis</th><th style="text-align:right">CO2e (kg)</th><th>Scope</th>'
        : this.scopeReportType === 'usage'
          ? '<th>Sensor</th><th>Zähler Info</th><th>Ext. Sensor Id</th><th>Marktlokation</th><th>Objekt</th><th>Von</th><th>Bis</th><th style="text-align:right">Verbrauch</th><th>Einheit</th><th style="text-align:right">Kosten (€)</th>'
          : '<th>Sensor</th><th>Zähler Info</th><th>Ext. Sensor Id</th><th>Marktlokation</th><th>Objekt</th><th>Datum</th><th style="text-align:right">Zählerstand</th><th>Einheit</th><th>OBIS</th>'

      const buildTable = (totals, bgStyle) => `
        <table>
          <thead><tr>${thead}</tr></thead>
          <tbody>${totals.map(t => buildRow(t, bgStyle)).join('')}</tbody>
        </table>`

      let tableHtml = ''
      if (showBothGroups) {
        tableHtml = `<h3 style="margin-top:16px;">Hauptzähler</h3>${buildTable(mainTotals, 'background-color:#f0f8ff;')}`
        if (subTotals.length) {
          tableHtml += `<h3 style="margin-top:24px;">Unterzähler</h3>${buildTable(subTotals, '')}`
        }
      } else {
        tableHtml = buildTable(mainTotals.length ? mainTotals : allTotals, '')
      }

      const reportTitle = this.scopeReportType === 'co2'
        ? this.$t('homePage.co2Report')
        : this.scopeReportType === 'usage'
          ? this.$t('homePage.usageReport')
          : this.$t('homePage.dailyTotals')

      const emissionsHtml = emissions.length
        ? `
  <h3 style="margin-top: 24px;">Emissionsfaktoren</h3>
  <table>
    <thead><tr>
      <th>Typ</th><th>Name</th><th>CO2e</th><th>Grundpreis (€/Monat)</th><th>Arbeitspreis (€/Einheit)</th>
    </tr></thead>
    <tbody>
      ${emissions.map(e => {
        const type = e.emissionType ? e.emissionType.type : ''
        const unit = this.emissionTypeUnit(type)
        return `<tr>
          <td>${this.emissionTypeLabel(type)}</td>
          <td>${e.description || ''}</td>
          <td>${e.co2e != null ? e.co2e + ' kg/' + unit : ''}</td>
          <td style="text-align:right">${e.basePrice != null ? Number(e.basePrice).toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '–'}</td>
          <td style="text-align:right">${e.unitPrice != null ? Number(e.unitPrice).toLocaleString(navigator.language, { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : '–'}</td>
        </tr>`
      }).join('')}
    </tbody>
  </table>`
        : ''

      const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${reportTitle}</title>
  <style>
    body { font-family: Arial, sans-serif; font-size: 10px; padding: 20px; }
    h2 { margin-bottom: 4px; }
    h3 { margin-bottom: 4px; }
    .facility-info { margin-bottom: 16px; color: #333; }
    .facility-info p { margin: 2px 0; }
    table { border-collapse: collapse; width: 100%; margin-top: 10px; }
    th { background: #4C4a46; color: #fff; padding: 6px 8px; text-align: left; }
    td { border-bottom: 1px solid #ddd; padding: 4px 8px; }
    .footnote { margin-top: 24px; font-size: 11px; color: #666; border-top: 1px solid #ccc; padding-top: 8px; }
  </style>
</head>
<body>
  <h2>${reportTitle}</h2>
  <div class="facility-info">
    <p><strong>${facility.name || ''}</strong></p>
    ${facility.description ? `<p>${facility.description}</p>` : ''}
    <p>${orgName}</p>
  </div>
  ${tableHtml}
  ${emissionsHtml}
  <div class="footnote">
    ${this.$t('homePage.printFooter', { company: (this.company && (this.company.legalName || this.company.name)) || 'Clever Home Labs GmbH', name: userName, date: printDate })}
  </div>
</body>
</html>`

      const iframe = document.createElement('iframe')
      iframe.style.position = 'fixed'
      iframe.style.width = '0'
      iframe.style.height = '0'
      iframe.style.border = 'none'
      document.body.appendChild(iframe)
      iframe.contentDocument.open()
      iframe.contentDocument.write(html)
      iframe.contentDocument.close()
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
      setTimeout(() => document.body.removeChild(iframe), 1000)
    },
    paddedShortDateString (date) {
      const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
      const month = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(date)
      const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
      let monthString = `0${month}`
      if (month > 9) {
        monthString = `${month}`
      }
      return `${year}-${monthString}-${day}`
    },
    loadWeeklyAggregations () {
      this.clearError()
      this.isLoading = true
      this.statsDataLoading = true
      this.$store.commit('clearError')
      const selected = new Date(this.selectedChartDate)
      let fromDate
      if (this.statsDuration === 31) {
        fromDate = moment(selected).subtract(1, 'months').toDate()
      } else {
        fromDate = moment(selected).subtract(this.statsDuration, 'days').toDate()
      }
      const untilDate = moment(selected).toDate()
      /* eslint-disable no-console */
      // console.log('loadWeeklyAggregations: ' + this.paddedShortDateString(fromDate))
      // const payload = { cdcSensorId: this.currentSensor, fromDate: `${year}-${monthString}-${day}`, untilDate: `${year}-${monthString}-${day}` }
      const payload = { cdcSensorId: this.currentSensor.id, fromDate: this.paddedShortDateString(fromDate), untilDate: this.paddedShortDateString(untilDate) }
      this.$store.dispatch('getSensorAggregations', payload)
      // this.sensorAggregations = this.$store.sensorAggregations
      // this.$forceUpdate()
    },
    isViewingCurrentTime () {
      if (!this.selectedChartDate) return true
      const now = new Date()
      if (this.chartDuration === 1) {
        // Hour mode: viewing "now" if the selected end-time is within one chartDuration window of now
        return Math.abs(now - this.selectedChartDate) < this.chartDuration * 60 * 60 * 1000
      } else {
        // Day mode: viewing "now" if the selected date is today
        return this.selectedChartDate.toDateString() === now.toDateString()
      }
    },
    loadLatestCDCDataValues () {
      // mounted() and the client watcher both call this on login, and the
      // 60 s timer may fire while a slow response is still on its way —
      // one request at a time is enough (guard expires after 30 s so an
      // error or a lost response never blocks the refresh for good).
      if (this.latestDataPendingSince && Date.now() - this.latestDataPendingSince < 30000) {
        return
      }
      this.latestDataPendingSince = Date.now()
      this.clearError()
      this.isLoading = true
      this.$store.commit('clearError')
      const payload = { organizationId: this.client.organization.id }
      this.$store.dispatch('getLatestCDCDataValues', payload)
      if (this.currentFacility != null) {
        this.facilitiesLocal.forEach(facility => {
          if (facility.id === this.currentFacility.id) {
            this.currentFacility = facility
            if (this.currentDevice != null) {
              facility.devices.forEach(device => {
                if (device.id === this.currentDevice.id) {
                  this.currentDevice = device
                  if (this.currentSensor.id > -1) {
                    device.sensors.forEach(sensor => {
                      if (sensor.id === this.currentSensor.id) {
                        this.currentSensor = sensor
                      }
                    })
                  }
                }
              })
            }
          }
        })
      }
      if (this.sensorMode && this.currentSensor.id > -1 && this.isViewingCurrentTime()) {
        if (this.chartDuration === 1) {
          this.selectedChartDate = new Date()
        } else {
          this.loadDataValues()
        }
      }
      this.$forceUpdate()
    },
    showFacility (facility) {
      this.currentFacility = facility
    },

    // ---- edit pencils in the monitoring view ------------------------
    //
    // The edit modals copy their prop object and PUT it back COMPLETELY.
    // The latestdata tree only carries a subset (and renames statusinfo
    // to meterinfo), so passing tree objects would 400 on required fields
    // or silently null description/geo/extra. Therefore: load the full
    // object from the admin endpoint first, then open the modal. Services
    // are called directly — the store dispatches (getFacilityData etc.)
    // would clobber state.organizations, i.e. the monitoring tree.

    reloadData () {
      // PageViewMixin.modalClosed(anyChanges) calls this after a save
      this.loadLatestCDCDataValues()
    },
    showEditModal (domId) {
      this.$nextTick(() => {
        const el = document.querySelector(domId)
        if (!el) return
        // eslint-disable-next-line global-require
        const { Modal } = require('bootstrap')
        Modal.getOrCreateInstance(el, { backdrop: 'static' }).show()
      })
    },
    editLoadFailed (error) {
      this.errorMessage = this.localizedBackendMessage ? this.localizedBackendMessage(error.message) : (error.message || 'Failed')
    },
    openEditFacility (facility) {
      facilityService.getFacilityData(this.client.organization.id).then((data) => {
        const full = ((data && data.facilities) || []).find(f => f.id === facility.id)
        if (!full) return
        this.editFacilityData = full
        this.editFacilityTimestamp = new Date().toISOString()
        this.showEditModal('#editFacilityModal')
      }).catch(this.editLoadFailed)
    },
    openEditDevice (device) {
      // device pencils only render inside an opened facility, so
      // currentFacility is a reliable fallback for the parent id
      const facilityId = device.facilityid != null ? device.facilityid : (this.currentFacility ? this.currentFacility.id : null)
      if (facilityId == null) return
      cdcdeviceService.getCDCDeviceData(facilityId).then((data) => {
        const full = ((data && data.cdcdevices) || []).find(d => d.id === device.id)
        if (!full) return
        this.editParentFacility = this.currentFacility || this.editParentFacility
        this.editDeviceData = full
        this.editDeviceTimestamp = new Date().toISOString()
        this.showEditModal('#editCDCDeviceModal')
      }).catch(this.editLoadFailed)
    },
    openEditSensor (sensor) {
      const device = this.deviceForSensor(sensor)
      if (!device) return
      cdcsensorService.getCDCSensorData(device.id).then((data) => {
        const full = ((data && data.cdcsensors) || []).find(s => s.id === sensor.id)
        if (!full) return
        this.editParentFacility = this.currentFacility || this.editParentFacility
        this.editParentDevice = device
        this.editSensorData = full
        this.editSensorTimestamp = new Date().toISOString()
        this.showEditModal('#editCDCSensorModal')
      }).catch(this.editLoadFailed)
    },
    // Jump target for the dashboard status tiles: switch to the monitoring
    // tab and open the facility the clicked entry belongs to.
    openFacilityFromDashboard (facilityId) {
      this.pageMode = 'monitoring'
      for (const organization of this.organizations || []) {
        for (const facility of organization.facilities || []) {
          if (facility.id === facilityId) {
            this.showFacility(facility)
            return
          }
        }
      }
    },
    showSensor (sensor) {
      const device = this.deviceForSensor(sensor)
      //
      // FIXME! we need an aging test as well!
      //
      if (!this.currentDevice || this.currentDevice.id !== device.id) {
        this.currentDevice = device
        this.loadDataValues()
      }
      this.currentSensor = sensor
      this.sensorMode = true
    },
    backToOverview () {
      this.backToFacility()
      this.currentDevice = null
      this.currentFacility = null
    },
    backToFacility () {
      this.currentSensor = { id: -1, name: '' }
      this.sensorMode = false
    },
    isOutdated (timestamp) {
      return monitoringStatus.isOutdated(timestamp)
    },
    maxLastSeen (facility) {
      return monitoringStatus.maxLastSeen(facility)
    },
    toggleShowHiddenFacilities () {
      this.showHiddenFacilities = !this.showHiddenFacilities
      this.$forceUpdate()
    },
    facilityDisabledCount () {
      let count = 0
      if (this.facilitiesLocal) {
        for (const facility of this.facilitiesLocal) {
          let isDisabeld = true
          for (const device of facility.devices) {
            if (device.enabled) {
              isDisabeld = false
            }
          }
          if (isDisabeld) {
            count += 1
          }
        }
      }
      return count
    },
    facilityImagePath (facility) {
      if (facility != null && facility.type != null) {
        return '/images/ISO_Building_' + facility.type + '.png'
      }
      return '/images/ISO_Building_0.png'
    },
    facilityIsDisabled (facility) {
      return monitoringStatus.facilityIsDisabled(facility)
    },
    facilityStyleHasAlerts (facility) {
      if (this.facilityIsDisabled(facility)) {
        return '--severity-stops: rgba(242,242,242,1) 0%, rgba(242,242,242,1) 100%;'
      }
      if (this.facilityIsOutdated(facility)) {
        return '--severity-stops: rgba(255,128,0,1) 0%, rgba(255,128,0,1) 100%;'
      }
      // var outdated = this.isOutdated(this.maxLastSeen(facility))
      const counts = { sensorCount: 0, sensorsWithAlerts: 0, sensorsWithCritical: 0, sensorsWithWarning: 0, sensorsWithInfo: 0, sensorsWithNone: 0, sensorWithUnknown: 0 }

      for (const device of facility.devices) {
        if (device.enabled === true) {
          const deviceCount = this.deviceAlertCounts(device)
          counts.sensorCount += deviceCount.sensorCount
          counts.sensorsWithAlerts += deviceCount.sensorsWithAlerts
          counts.sensorsWithCritical += deviceCount.sensorsWithCritical
          counts.sensorsWithWarning += deviceCount.sensorsWithWarning
          counts.sensorsWithInfo += deviceCount.sensorsWithInfo
          counts.sensorsWithNone += deviceCount.sensorsWithNone
          counts.sensorWithUnknown += deviceCount.sensorWithUnknown
        }
      }
      return '--severity-stops: ' + this.buildGradientStyle(counts) + ';'
    },
    facilityHasAlerts (facility) {
      if (this.facilityIsDisabled(facility)) {
        return false
      }
      const outdated = this.isOutdated(this.maxLastSeen(facility))
      let devicesWithAlerts = 0
      let deviceCount = 1 // 1 is for the facility
      if (!outdated) {
        for (const device of facility.devices) {
          deviceCount += 1
          if (this.deviceIsOutdated(device)) {
            devicesWithAlerts += 1
          }
        }
        // Build colour stops for the facility severity gradient.
        // The CSS at the bottom wraps these into horizontal (classic)
        // or vertical-strip (subtle) gradients via --severity-stops.
        if (devicesWithAlerts === 0) {
          // will not be used (caller only consumes when alerts exist)
        } else {
          const stops = 'rgba(251,199,66,1) 0%, rgba(251,199,66,1) ' +
            (((devicesWithAlerts / deviceCount) * 100)) + '%, ' +
            'rgba(127,232,127,1) 100%'
          this.facilityGradient = stops
        }
      }

      return devicesWithAlerts > 0
    },
    facilityIsOutdated (facility) {
      if (this.facilityIsDisabled(facility)) {
        return false
      }
      const outdated = this.isOutdated(this.maxLastSeen(facility))
      /*
      if (!outdated) {
        for (const device of facility.devices) {
          if (this.deviceIsOutdated(device)) {
            outdated = true
            break
          }
        }
      }
      */
      return outdated
    },
    fromNowFacilityDisplay (facility) {
      const max = this.maxLastSeen(facility)
      return max > 0 ? moment(max).fromNow() : '?'
    },
    visibleDevices (facility) {
      const devices = []
      facility.devices.forEach(device => {
        if (device.enabled) {
          devices.push(device)
        }
      })
      return devices
    },
    deviceName (device) {
      // The manual-meter device is created per facility by the backend and
      // carries a fixed English name in the database. Label it from the
      // translations instead, so the German UI does not read "Virtual Meters"
      // and existing rows do not have to be renamed.
      if (device.virtual === true) {
        return this.$t('deviceNames.virtual')
      }
      return device.name ? device.name : device.apikey
    },
    facilityAlertIcon (facility) {
      let icon = 'blank'
      if (this.facilityIsDisabled(facility)) {
        icon = 'icloud.slash'
      } else {
        for (const device of facility.devices) {
          const lastseen = device.lastseen
          if (lastseen && this.isOutdated(moment(lastseen).valueOf())) {
            return '/images/exclamationmark.bubble.png'
          }
          var sensorWithHighestAlert = null
          let highestReason = -1
          for (const sensor of device.sensors) {
            if (sensor.enabled === true) {
              const reason = this.sensorAlertReason(sensor)
              if (sensorWithHighestAlert === null || reason > highestReason) {
                highestReason = reason
                sensorWithHighestAlert = sensor
              }
            }
          }
        }
        return this.sensorAlertIcon(sensorWithHighestAlert)
      }
      return '/images/' + icon + '.png'
    },
    /*
    deviceAlertIcon (device) {
      var icon = 'blank'
      if (!device.enabled) {
        icon = 'icloud.slash'
      } else {
        var outdated = true
        const lastseen = device.lastseen
        if (lastseen) {
          outdated = this.isOutdated(moment(lastseen).valueOf())
        }
        if (outdated === true) {
          icon = 'exclamationmark.bubble'
        } else {
          return this.deviceAlertReason(device).icon
        }
      }
      return '/images/' + icon + '.png'
    },
    */
    facilityHideReasonNumber (facility) {
      const facilityAlertReason = this.facilityAlertReasons(facility)
      if (facilityAlertReason.reasons.length < 2) { // if there are 0 or 1 reasons don't show
        return true
      }
      return false
    },
    facilityAlertReasons (facility) {
      if (this.facilityIsDisabled(facility)) {
        const icon = '/images/icloud.slash.png'
        return { reasons: [AlertReason.DEVICE_DISABLED], highestReason: AlertReason.DEVICE_DISABLED, icon, text: this.alertReasonText(AlertReason.DEVICE_DISABLED) }
      } else {
        const facilityAlertReasons = { reasons: [], highestReason: -1, icon: '/images/blank.png', text: '' }
        for (const device of (facility.devices || [])) {
          if (device.enabled === true) {
            const deviceAlertReason = this.deviceAlertReason(device)
            facilityAlertReasons.reasons.push(...deviceAlertReason.reasons)
            if (facilityAlertReasons.highestReason < deviceAlertReason.highestReason) {
              facilityAlertReasons.highestReason = deviceAlertReason.highestReason
              facilityAlertReasons.icon = deviceAlertReason.icon
              facilityAlertReasons.text = deviceAlertReason.text
            }
          }
        }
        return facilityAlertReasons
      }
    },
    deviceHideReasonNumber (device) {
      const deviceAlertReason = this.deviceAlertReason(device)
      if (deviceAlertReason.reasons.length < 2) { // if there are 0 or 1 reasons don't show
        return true
      }
      return false
    },
    deviceAlertReason (device) {
      // Core rules live in the module; only the presentation (icon path +
      // translated text) is attached here.
      const core = monitoringStatus.deviceAlertReasonCore(device)
      if (core.highestReason === AlertReason.DEVICE_DISABLED && !device.enabled) {
        return { reasons: core.reasons, highestReason: core.highestReason, icon: '/images/icloud.slash.png', text: this.alertReasonText(AlertReason.DEVICE_DISABLED) }
      }
      if (core.highestReason === AlertReason.DEVICE_CONTACT && core.sensorWithHighestAlert === null) {
        return { reasons: core.reasons, highestReason: core.highestReason, icon: '/images/exclamationmark.bubble.png', text: this.alertReasonText(AlertReason.DEVICE_CONTACT) }
      }
      return { reasons: core.reasons, highestReason: core.highestReason, icon: this.sensorAlertIcon(core.sensorWithHighestAlert), text: this.sensorAlertReasonText(core.sensorWithHighestAlert) }
    },
    deviceStyleHasAlerts (device) {
      if (device == null || device.enabled === false) {
        return '--severity-stops: rgba(242,242,242,1) 0%, rgba(242,242,242,1) 100%;'
      }
      const counts = this.deviceAlertCounts(device)

      return '--severity-stops: ' + this.buildGradientStyle(counts) + ';'
    },
    deviceAlertCounts (device) {
      return monitoringStatus.deviceAlertCounts(device)
    },
    deviceHasAlerts (device) {
      if (!device.enabled) {
        return false
      }
      let outdated = true
      const lastseen = device.lastseen
      if (lastseen) {
        outdated = this.isOutdated(moment(lastseen).valueOf())
      }
      // outdated is already covered we check for Alerts
      if (!outdated) {
        this.deviceGradient = this.buildGradientStyle(this.deviceAlertCounts(device))
        return true
      }
      return false
    },
    buildGradientStyle (counts) {
      return monitoringStatus.buildGradientStyle(counts)
    },
    deviceIsOutdated (device) {
      if (!device.enabled) {
        return false
      }
      let outdated = true
      const lastseen = device.lastseen
      if (lastseen) {
        outdated = this.isOutdated(moment(lastseen).valueOf())
      }
      // although the device might be ok a single sensor may be not!
      if (!outdated) {
        for (const sensor of device.sensors) {
          if (this.sensorIsOutdated(sensor)) {
            outdated = true
            break
          }
        }
      }
      return outdated
    },
    fromNowDeviceDisplay (device) {
      const lastseen = device ? device.lastseen : null
      return lastseen ? moment(lastseen).fromNow() : '?'
    },
    recordedtime (sensor) {
      const data = sensor ? sensor.data : null
      if (data && data.length > 0) {
        const entry = data[0]
        if (entry && entry.recordedtime) {
          return entry.recordedtime
        }
      }
      return null
    },
    // The measurement time a chart point belongs on — see
    // utils/send-on-change.js (mirrors CDCData.getEffectiveTime()).
    effectiveTime (dataPackage) {
      return sendOnChange.effectiveTime(dataPackage)
    },
    deviceForSensor (sensor) {
      if (sensor && this.currentFacility) {
        for (const device of this.currentFacility.devices) {
          if (device.id === sensor.cdcdeviceid) {
            return device
          }
        }
      }
      return null
    },
    visibleSensors (device) {
      const sensors = []
      device.sensors.forEach(sensor => {
        if (sensor.enabled) {
          sensors.push(sensor)
        }
      })
      return objectSorter.sortedArray(sensors, 'asc', 'originalid')
    },
    hasCollections (device) {
      return device.collections && device.collections.length > 0
    },
    visibleCollections (device) {
      const collections = []
      device.collections.forEach(collection => {
        if (collection.name && collection.name.length > 0) {
          collection.enabled = true // artificial!!!
          collection.type = collection.sensortype
          collection.cdcdeviceid = device.id // FIXME!!! should be ommited
          // Lookup of model-type in string table
          collection.model = this.$t('sensorModel.' + collection.modeltype)
          collections.push(collection)
        }
      })
      return objectSorter.sortedArray(collections, 'asc', 'name')
    },
    // Max-silence window (minutes) for send-on-change sensors (CS-* v5),
    // or null when the sensor is not known to be send-on-change. Priority:
    // explicit json override `maxSilenceMin` > vt:36 in the latest package >
    // sticky in-session observation. See utils/send-on-change.js.
    maxSilenceMinutesForSensor (sensor) {
      return monitoringStatus.maxSilenceMinutesForSensor(sensor)
    },
    sensorIsSendOnChange (sensor) {
      return this.maxSilenceMinutesForSensor(sensor) != null
    },
    sensorIsOutdated (sensor) { // see MER-91
      return monitoringStatus.sensorIsOutdated(sensor)
    },
    sensorStyleAlertStatus (sensor) {
      // Emit only the colour stops as the CSS custom property
      // `--severity-stops`. Both classic (full-card horizontal
      // gradient) and subtle (left-strip vertical gradient) modes
      // construct their own gradient from this single source via
      // the CSS rules at the bottom of this component. Single-colour
      // states get a degenerate "0%..100% same colour" stop list so
      // the same gradient pipeline still works.
      const result = this.sensorAlertStatus(sensor)
      let stops
      switch (result) {
        case -1: stops = 'rgba(127,232,127,1) 0%, rgba(255,181,3,1) 100%'; break
        case 0: stops = 'rgba(127,232,127,1) 0%, rgba(127,232,127,1) 100%'; break
        case 1: stops = 'rgba(255,181,3,1) 0%, rgba(255,181,3,1) 100%'; break
        case 2: stops = 'rgba(255,128,0,1) 0%, rgba(255,128,0,1) 100%'; break
        case 3: stops = 'rgba(228,0,0,1) 0%, rgba(228,0,0,1) 100%'; break
        default: stops = 'rgba(127,232,127,1) 0%, rgba(127,232,127,1) 100%'
      }
      return '--severity-stops: ' + stops + ';'
    },
    sensorAlertStatus (sensor) {
      return monitoringStatus.sensorAlertStatus(sensor)
    },
    sensorAlertReasonText (sensor) {
      return this.alertReasonText(this.sensorAlertReason(sensor))
    },
    highestTriggeredEventSeverity (sensor) {
      const events = sensor && sensor.triggeredEvents
      if (!events || events.length === 0) return 0
      let highest = 0
      for (const e of events) {
        const code = e && typeof e.severityCode === 'number' ? e.severityCode : 0
        if (code > highest) highest = code
      }
      return highest
    },
    hasTriggeredEvents (sensor) {
      return sensor && sensor.triggeredEvents && sensor.triggeredEvents.length > 0
    },
    // Any reason that should make the warning icon clickable. Includes both
    // SensorEvent triggers and non-event reasons (stale, watergaurd, …).
    sensorHasAnyAlert (sensor) {
      return !!sensor && this.sensorAlertReason(sensor) !== AlertReason.NONE
    },
    deviceHasAnyAlert (device) {
      return !!device && this.deviceAlertReason(device).reasons.length > 0
    },
    facilityHasAnyAlert (facility) {
      return !!facility && this.facilityAlertReasons(facility).reasons.length > 0
    },
    // Sort priority for monitoring-view facility ordering.
    // critical=3 > warning=2 > info=1 > everything else=0.
    // DEVICE_DISABLED maps to severity 4 in severityForReason but ranks as 0
    // here because a disabled facility is an intentional state, not urgency.
    facilitySeverityForSort (facility) {
      const reasons = this.facilityAlertReasons(facility).reasons
      if (!reasons || reasons.length === 0) return 0
      let max = 0
      for (const r of reasons) {
        const sev = this.severityForReason(r)
        const rank = (sev === 3 || sev === 2 || sev === 1) ? sev : 0
        if (rank > max) max = rank
      }
      return max
    },
    alertIconTooltip (sensor) {
      if (!this.sensorHasAnyAlert(sensor)) {
        return this.sensorAlertReasonText(sensor)
      }
      return this.sensorAlertReasonText(sensor) + ' — ' + this.$t('homePage.clickForDetails')
    },
    deviceAlertTooltip (device) {
      if (!this.deviceHasAnyAlert(device)) {
        return this.deviceAlertReason(device).text
      }
      return this.deviceAlertReason(device).text + ' — ' + this.$t('homePage.clickForDetails')
    },
    facilityAlertTooltip (facility) {
      if (!this.facilityHasAnyAlert(facility)) {
        return this.facilityAlertReasons(facility).text
      }
      return this.facilityAlertReasons(facility).text + ' — ' + this.$t('homePage.clickForDetails')
    },
    // Build a flat list of alert items for the modal — one entry per
    // triggered SensorEvent (with full detail) plus one entry per non-event
    // reason that applies (stale data, watergaurd, sensor code, …). Higher
    // severity first.
    alertItemsForSensor (sensor, includeContextName = false) {
      const items = []
      if (!sensor) return items

      if (sensor.triggeredEvents && sensor.triggeredEvents.length > 0) {
        for (const e of sensor.triggeredEvents) {
          items.push({
            severityCode: e.severityCode != null ? e.severityCode : 0,
            label: e.message || this.alertReasonText(AlertReason.SENSOR_EVENT),
            sensorName: includeContextName ? sensor.name : '',
            operatorCode: e.alertEventCode,
            eventValue: e.eventValue,
            threshold: e.threshold,
            observedValue: e.observedValue,
            paused: !!e.paused
          })
        }
      }

      const reason = this.sensorAlertReason(sensor)
      const eventReasons = [AlertReason.SENSOR_ALERT, AlertReason.SENSOR_WARNING, AlertReason.SENSOR_EVENT]
      if (reason !== AlertReason.NONE && !eventReasons.includes(reason)) {
        // Non-event reason (stale data, watergaurd, air quality, sensor code, …)
        items.push({
          severityCode: this.severityForReason(reason),
          label: this.alertReasonText(reason),
          sensorName: includeContextName ? sensor.name : ''
        })
      }
      return this.sortBySeverityDesc(items)
    },
    alertItemsForDevice (device) {
      const items = []
      if (!device) return items
      if (device.enabled === false) {
        items.push({
          severityCode: this.severityForReason(AlertReason.DEVICE_DISABLED),
          label: this.alertReasonText(AlertReason.DEVICE_DISABLED)
        })
        return items
      }
      // Device-level: outdated heartbeat (skipped for virtual devices)
      if (device.virtual !== true) {
        const lastseen = device.lastseen
        const outdated = lastseen ? this.isOutdated(moment(lastseen).valueOf()) : true
        if (outdated) {
          items.push({
            severityCode: this.severityForReason(AlertReason.DEVICE_CONTACT),
            label: this.alertReasonText(AlertReason.DEVICE_CONTACT)
          })
        }
      }
      // Aggregate sensor-level entries with sensor name as context
      for (const sensor of device.sensors || []) {
        if (sensor.enabled === false) continue
        for (const it of this.alertItemsForSensor(sensor, true)) {
          items.push(it)
        }
      }
      return this.sortBySeverityDesc(items)
    },
    alertItemsForFacility (facility) {
      const items = []
      if (!facility) return items
      if (this.facilityIsDisabled(facility)) {
        items.push({
          severityCode: this.severityForReason(AlertReason.DEVICE_DISABLED),
          label: this.alertReasonText(AlertReason.DEVICE_DISABLED)
        })
        return items
      }
      for (const device of facility.devices || []) {
        if (device.enabled === false) continue
        for (const it of this.alertItemsForDevice(device)) {
          items.push(it)
        }
      }
      return this.sortBySeverityDesc(items)
    },
    severityForReason (reason) {
      return monitoringStatus.severityForReason(reason)
    },
    sortBySeverityDesc (items) {
      return items.slice().sort((a, b) => (b.severityCode || 0) - (a.severityCode || 0))
    },
    showAlertsForSensor (sensor) {
      this.openAlertsModal(sensor.name, this.alertItemsForSensor(sensor, false))
    },
    canSwapMeter (sensor) {
      // Caretaker / admin only. Consumption-meter types only:
      // CDC_POWER(0), CDC_GAS(1), CDC_WATER(2), CDC_HEAT(3). Virtual
      // sensors qualify too — their physical meter can be replaced; the
      // CDCSensor entity stays and the bridge records the meter change.
      // Computed sensors have no meter behind them, nothing to swap.
      if (!sensor || !this.client || this.client.role < 3) return false
      if (this.isComputedSensor(sensor)) return false
      return [0, 1, 2, 3].includes(sensor.type)
    },
    openSwapModalForSensor (sensor) {
      if (!this.canSwapMeter(sensor) || !this.currentFacility) return
      // Resolve the meteringpoint for this sensor via the facility list,
      // then preload candidate sensors of the same type for the dropdown.
      meteringpointsService.listForFacility(this.currentFacility.id).then((data) => {
        const list = (data && data.meteringpoints) || []
        const mp = list.find(m => m.currentSensorId === sensor.id)
        if (!mp) {
          this.errorMessage = 'No meteringpoint resolved for this sensor — Phase 2 backfill may be incomplete.'
          return
        }
        // Candidate sensors: all sensors in the facility of the same type
        const candidates = []
        if (this.currentFacility.devices) {
          for (const device of this.currentFacility.devices) {
            for (const s of (device.sensors || [])) {
              if (s.type === sensor.type) candidates.push(s)
            }
          }
        }
        this.swapModalMpId = mp.id
        this.swapModalCandidates = candidates
        this.swapModalCurrentSensor = sensor
        this.swapModalTimestamp = new Date().toISOString()
        this.$nextTick(() => {
          const el = document.querySelector('#swapSensorModal')
          if (!el) return
          // eslint-disable-next-line global-require
          const { Modal } = require('bootstrap')
          Modal.getOrCreateInstance(el, { backdrop: 'static' }).show()
        })
      }).catch((error) => {
        this.errorMessage = this.localizedBackendMessage ? this.localizedBackendMessage(error.message) : (error.message || 'Failed')
      })
    },
    showAlertsForDevice (device) {
      this.openAlertsModal(this.deviceName(device), this.alertItemsForDevice(device))
    },
    showAlertsForFacility (facility) {
      this.openAlertsModal(facility.name, this.alertItemsForFacility(facility))
    },
    openAlertsModal (title, items) {
      this.alertsModalTitle = title || ''
      this.alertsModalItems = items || []
      this.alertsModalTimestamp = new Date().toISOString()
      this.$nextTick(() => {
        const el = document.querySelector('#sensorAlertsModal')
        if (!el) return
        // eslint-disable-next-line global-require
        const { Modal } = require('bootstrap')
        Modal.getOrCreateInstance(el, { backdrop: 'static' }).show()
      })
    },
    alertReasonText (alertReason) {
      switch (alertReason) {
        case AlertReason.NONE: return this.$t('sensorAlertReason.None')
        case AlertReason.DEVICE_DISABLED: return this.$t('sensorAlertReason.DeviceIsDisabled')
        case AlertReason.DEVICE_CONTACT: return this.$t('sensorAlertReason.NoContactToDevice')
        case AlertReason.STALE_DATA: return this.$t('sensorAlertReason.StaleData')
        case AlertReason.BATTERY_LOW: return this.$t('sensorAlertReason.BatteryIsLow')
        case AlertReason.USAGE_LIMIT: return this.$t('sensorAlertReason.UsageLimitReached')
        case AlertReason.SENSOR_WARNING: return this.$t('sensorAlertReason.SensorWarning')
        case AlertReason.SENSOR_ALERT: return this.$t('sensorAlertReason.SensorAlert')
        case AlertReason.SENSOR_DISABLED: return this.$t('sensorAlertReason.SensorIsDisbled')
        case AlertReason.NO_SENSORDATA: return this.$t('sensorAlertReason.NoSensorData')
        case AlertReason.SENSOR_EVENT: return this.$t('sensorAlertReason.EventWasTriggered')
        case AlertReason.UNKNOWN: return this.$t('sensorAlertReason.Unknown')
        default:
          return this.$t('sensorAlertReason.Unknown')
      }
    },
    sensorAlertReason (sensor) {
      return monitoringStatus.sensorAlertReason(sensor)
    },
    fromNowSensorDisplay (sensor) {
      // A carried-over first-glance value (see valuetime below) is older than
      // the package it came with — show its own age, not the package's.
      const recordedtime = this.firstGlanceValueTime(sensor) || this.recordedtime(sensor)
      return recordedtime ? moment(recordedtime).fromNow() : '?'
    },
    // private — `valuetime` is set by the latestdata API on values the latest
    // package did not carry itself: the server appends the newest older reading
    // of that measurand (v5 sensors send battery/temperature hourly, RSSI only on
    // the newest record of a batch, the CDC gas zero-send carries the rate alone).
    // Such a value is still the last known reading, but its age is its own.
    valueAsOfDisplay (value) {
      return value && value.valuetime ? this.$t('homePage.valueAsOf', { ago: moment(value.valuetime).fromNow() }) : ''
    },
    // private
    valueAsOfTitle (value) {
      return value && value.valuetime ? moment(value.valuetime).format('LLL') : ''
    },
    // private — valuetime of the value the first tile shows, null when that
    // value was measured in the latest package (or there is none)
    firstGlanceValueTime (sensor) {
      const datapackage = this.dataPackageForSensor(sensor)
      if (!datapackage || !datapackage.values) {
        return null
      }
      let pair = null
      try {
        pair = this.effectiveFirstGlancePair(sensor) || this.firstGlanceSystemPartAndType(sensor)
      } catch (e) {
        return null
      }
      const value = pair ? this.findSensorValueForSystemPartAndType(sensor, pair, datapackage) : null
      return value && value.valuetime ? value.valuetime : null
    },
    totalFromNowSensorDisplay (sensor) {
      const recordedtime = sensor.total.lastupdate
      return recordedtime ? moment(recordedtime).fromNow() : '?'
    },
    // private
    findSensorValueForSystemPartAndType (sensor, pair, datapackage) {
      if (sensor && datapackage) {
        for (const value of datapackage.values) {
          if (value.systempart === pair.systempart && value.type === pair.valuetype) {
            return value
          }
        }
      }
      return null
    },
    // private
    dataPackageForSensor (sensor) {
      return sensor && sensor.data && sensor.data.length > 0 ? sensor.data[0] : null
    },
    // private func returning single cdc-value object or null
    findFirstGlanceReadingInDataPackage (sensor, datapackage) {
      const pair = this.firstGlanceSystemPartAndType(sensor)
      return this.findSensorValueForSystemPartAndType(sensor, pair, datapackage)
    },
    // private
    findFirstGlanceReading (sensor) {
      const datapackage = this.dataPackageForSensor(sensor)
      return datapackage ? this.findFirstGlanceReadingInDataPackage(sensor, datapackage) : null
    },
    // private func return array of cdc-value objects or empty
    findFallbackMeasurementsForElectricityFirstGlanceReadingInDataPackage (sensor, datapackage) {
      const array = []
      if (datapackage) {
        const pairs = [{ systempart: 1, valuetype: 3 }, { systempart: 2, valuetype: 3 }, { systempart: 3, valuetype: 3 }]
        for (const pair of pairs) {
          const value = this.findSensorValueForSystemPartAndType(sensor, pair, datapackage)

          if (value) {
            array.push(value)
          }
        }
      }
      return array
    },
    // private
    findFallbackMeasurementsForElectricityFirstGlanceReading (sensor) {
      const datapackage = this.dataPackageForSensor(sensor)
      return datapackage ? this.findFallbackMeasurementsForElectricityFirstGlanceReadingInDataPackage(sensor, datapackage) : []
    },
    // private
    findFallbackMeterReadingMeasurementsForElectricityFirstGlanceReading (sensor) {
      const pair = { systempart: 4, valuetype: 9 }
      const datapackage = this.dataPackageForSensor(sensor)
      return this.findSensorValueForSystemPartAndType(sensor, pair, datapackage)
    },
    // private
    findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReadingInDataPackage (sensor, datapackage) {
      const pair = { systempart: 0, valuetype: 3 }
      return this.findSensorValueForSystemPartAndType(sensor, pair, datapackage)
    },
    // private
    findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReading (sensor) {
      const datapackage = this.dataPackageForSensor(sensor)
      return datapackage ? this.findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReadingInDataPackage(sensor, datapackage) : null
    },
    // private
    nonFirstGlanceValues (sensor) {
      // Gegen das Paar deduplizieren, das die erste Kachel WIRKLICH zeigt — nicht
      // gegen das nominelle. Sonst taucht ein Rueckfallwert (Einzelphase,
      // Zaehlerstand) noch einmal in der Liste auf.
      const pair = this.effectiveFirstGlancePair(sensor) || this.firstGlanceSystemPartAndType(sensor)
      return this.nonFirstGlanceValuesForSystemPartAndType(sensor, pair)
    },
    // private — welches Paar die erste Kachel tatsaechlich zeigt. Spiegelt die
    // Rueckfallkette von sensorValueDisplay: erst das nominelle Paar, dann bei
    // Strom die Phasensumme, dann Einzelphase, dann Zaehlerstand.
    effectiveFirstGlancePair (sensor) {
      const nominal = this.firstGlanceSystemPartAndType(sensor)
      if (this.findFirstGlanceReading(sensor)) {
        return nominal
      }
      if (sensor.type !== 0) {
        return nominal
      }
      const phases = this.findFallbackMeasurementsForElectricityFirstGlanceReading(sensor)
      if (phases.length > 1) {
        // Die Kachel zeigt die Summe der Phasen — das ist "Gesamt Leistung",
        // auch wenn der Sensor selbst kein (4,3) liefert (z.B. Kostal).
        return { systempart: 4, valuetype: 3 }
      }
      if (phases.length === 1) {
        return { systempart: phases[0].systempart, valuetype: phases[0].type }
      }
      const single = this.findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReading(sensor)
      if (single) {
        return { systempart: single.systempart, valuetype: single.type }
      }
      const meter = this.findFallbackMeterReadingMeasurementsForElectricityFirstGlanceReading(sensor)
      if (meter) {
        return { systempart: meter.systempart, valuetype: meter.type }
      }
      return null // Strom ohne jeden anzeigbaren Wert
    },
    // private — counter (Zählerstand) valuetypes per sensor type. Virtual
    // sensors never capture momentary values, so all other valuetypes are
    // suppressed from the dashboard.
    allowedValueTypesForVirtualSensor (sensorType) {
      switch (sensorType) {
        case 0: // Strom
        case 3: // Wärme
          return [9, 10] // Wh import + Wh export (rendered as kWh)
        case 1: // Gas
        case 2: // Wasser
          return [22] // m³
        default:
          return null
      }
    },
    // private
    nonFirstGlanceValuesForSystemPartAndType (sensor, pair) {
      const list = []
      const datapackage = this.dataPackageForSensor(sensor)
      if (!datapackage || datapackage.values.length === 0) {
        return list
      }
      const allowedTypes = this.isVirtualSensor(sensor) ? this.allowedValueTypesForVirtualSensor(sensor.type) : null
      for (const value of datapackage.values) {
        if (value.systempart === pair.systempart && value.type === pair.valuetype) {
          continue
        }
        if (value.type === 36) {
          // no-change count is transport metadata (feeds staleness/backfill),
          // not a reading worth listing
          continue
        }
        if (allowedTypes && !allowedTypes.includes(value.type)) {
          continue
        }
        // Frueher wurden bei Stromsensoren alle Phasenleistungen (Systemteil 0-3,
        // Typ 3) pauschal unterdrueckt. Bei einem Wechselrichter ohne Gesamtwert
        // (Kostal) waren das die einzigen Leistungswerte — L2 und L3 fehlten
        // komplett. Die Deduplizierung gegen das angezeigte Paar oben reicht.
        list.push(value)
      }
      return objectSorter.sortedArray(list, 'asc', 'systempart')
    },
    // private
    sensorsPossibleSystemPartsAndTypes (sensorType) {
      const systemPartsAndTypes = []

      switch (sensorType) {
        case 0: // power
          systemPartsAndTypes.push({ systempart: 4, valuetype: 3 })
          systemPartsAndTypes.push({ systempart: 4, valuetype: 9 })
          break
        case 1: // gas
          systemPartsAndTypes.push({ systempart: 4, valuetype: 13 })
          break
        case 2: // water
          systemPartsAndTypes.push({ systempart: 4, valuetype: 26 })
          break
        case 3: // heat
          systemPartsAndTypes.push({ systempart: 4, valuetype: 9 })
          break
        case 4: // temperature
          systemPartsAndTypes.push({ systempart: 20, valuetype: 16 })
          break
        case 5: // flooding
          systemPartsAndTypes.push({ systempart: 4, valuetype: 21 })
          break
        case 6: // pressure
          systemPartsAndTypes.push({ systempart: 4, valuetype: 24 })
          break
        case 8: // air
          systemPartsAndTypes.push({ systempart: 4, valuetype: 30 })
          break
        case 9: // generic aka collection
          systemPartsAndTypes.push({ systempart: 4, valuetype: 9 })
          break
        case 10: // environmental
          systemPartsAndTypes.push({ systempart: 28, valuetype: 15 })
          break
        default:
          break
      }
      return systemPartsAndTypes
    },
    // private
    firstGlanceSystemPartAndType (sensorOrType) {
      // Accepts either a sensor object or a raw type code. The object form
      // is needed to detect virtual sensors, which only carry counter
      // readings (Wh / m³ totals) — not the per-phase / per-minute pulse
      // values the physical defaults below assume.
      let sensor = null
      let sensorType = null
      if (typeof sensorOrType === 'object' && sensorOrType !== null) {
        sensor = sensorOrType
        sensorType = sensor.type
      } else {
        sensorType = sensorOrType
      }

      // Computed sensors write exactly the reading they are configured for.
      if (sensor && this.isComputedSensor(sensor)) {
        return computedSensors.computedPair(sensor)
      }

      if (sensor && this.isVirtualSensor(sensor)) {
        switch (sensorType) {
          case 0: // Strom — Wh total, displayed as kWh
          case 3: // Wärme — Wh total, displayed as kWh
            return { systempart: 4, valuetype: 9 }
          case 1: // Gas — m³ total
          case 2: // Wasser — m³ total
            return { systempart: 4, valuetype: 22 }
        }
        // Other sensor types (temperature, pressure, …) don't have a
        // counter-style virtual mode — fall through to the physical defaults.
      }

      let systemPart = -1
      let valueType = -1

      switch (sensorType) {
        case 0: // power
          systemPart = 4; valueType = 3
          break
        case 1: // gas
          systemPart = 4; valueType = 13
          break
        case 2: // water
          systemPart = 4; valueType = 26
          break
        case 3: // heat
          systemPart = 4; valueType = 9
          break
        case 4: // temperature,
        case 12: //  warmwater,
        case 13: // cooling
          systemPart = 20; valueType = 16
          break
        case 5: // flooding
          systemPart = 4; valueType = 21
          break
        case 6: // pressure
          systemPart = 4; valueType = 24
          break
        case 8: // air
          systemPart = 4; valueType = 30
          break
        case 9: // generic aka collection
          systemPart = 4; valueType = 9 // FIXME!! only preliminary
          break
        case 10: // environmental
          systemPart = 28; valueType = 15
          break
        case 14: // brightness
          systemPart = 29; valueType = 21
          break
        default:
          break
      }
      return { systempart: systemPart, valuetype: valueType }
    },
    providesFirstGlanceData (sensor) {
      const pair = this.firstGlanceSystemPartAndType(sensor)
      return (pair.systempart > -1 && pair.valuetype > -1)
    },
    collectionIcon (collection) {
      return this.sensorIcon(collection)
    },
    sensorAlertIcon (sensor) {
      let icon = 'blank'
      if (sensor) {
        const reason = this.sensorAlertReason(sensor)

        switch (reason) {
          case AlertReason.SENSOR_ALERT:
            icon = 'exclamationmark.bubble'
            break
          case AlertReason.STALE_DATA:
            icon = 'network.slash'
            break
          case AlertReason.BATTERY_LOW:
            icon = 'battery.25'
            break
          case AlertReason.DEVICE_CONTACT:
            icon = 'network.slash'
            break
          case AlertReason.SENSOR_DISABLED:
            icon = 'icloud.slash'
            break
          case AlertReason.USAGE_LIMIT:
            icon = 'questionmark.square.dashed'
            break
          case AlertReason.NO_SENSORDATA:
            icon = 'exclamationmark.triangle'
            break
          case AlertReason.SENSOR_EVENT:
            icon = 'bell.badge'
            break
          case AlertReason.NONE:
            icon = 'blank'
            break
          default:
            icon = 'exclamationmark.bubble'
        }
      }
      return '/images/' + icon + '.png'
    },
    sensorTypeLocalized (type) {
      switch (type) {
        case 0:
          return this.$t('homePage.type0')
        case 1:
          return this.$t('homePage.type1')
        case 2:
          return this.$t('homePage.type2')
        case 3:
          return this.$t('homePage.type3')
        case 4:
          return this.$t('homePage.type4')
        case 5:
          return this.$t('homePage.type5')
        case 6:
          return this.$t('homePage.type6')
        case 7:
          return this.$t('homePage.type7')
        case 8:
          return this.$t('homePage.type8')
        case 9:
          return this.$t('homePage.type9')
        case 10:
          return this.$t('homePage.type10')
        default:
          return ''
      }
    },
    sensorTypeIcon (type) {
      let icon = 'electricity'
      switch (type) {
        case 0:
          icon = 'sensor_power_circle'
          break
        case 1:
          icon = 'sensor_gas_circle'
          break
        case 2:
          icon = 'sensor_water_circle'
          break
        case 3:
          icon = 'sensor_heat_circle'
          break
        case 4:
          icon = 'sensor_temperature_circle'
          break
        case 5:
          icon = 'sensor_leakage_circle'
          break
        case 6:
          icon = 'sensor_pressure_circle'
          break
        case 7:
          icon = 'sensor_level_circle'
          break
        case 8:
          icon = 'sensor_air_circle'
          break
        case 9:
          icon = 'sensor_generic_circle'
          break
        case 10:
          icon = 'sensor_environment_circle'
          break
        default:
          icon = 'sensor_unknown_circle'
          break
      }
      return '/images/' + icon + '.png'
    },
    sensorIcon (sensor) {
      const icon = 'electricity'
      if (sensor) {
        return this.sensorTypeIcon(sensor.type)
      }
      return '/images/' + icon + '.png'
    },
    sensorSystemDisplay (sensor) {
      // Beschriftung aus demselben Paar, das sensorValueDisplay tatsaechlich
      // rechnet. Vorher trug die Phasensumme das Label der ersten Phase:
      // "L1 Leistung 1.346 W" bei einem Wert, der L1+L2+L3 war.
      if (!this.findFirstGlanceReading(sensor) && sensor.type !== 0) {
        if (sensor.type === 1) { // Gas
          return this.stringForSystemPartAndValueType(4, 13) // CDC_SYSTEM_TOTAL, CDC_M3_MINUTE_TYPE
        }
        if (sensor.type === 2) { // Water
          return this.stringForSystemPartAndValueType(4, 26) // CDC_SYSTEM_TOTAL, CDC_L_MIN_TYPE
        }
        return this.stringForSystemPartAndValueType(-1, -1)
      }
      const pair = this.effectiveFirstGlancePair(sensor)
      return pair
        ? this.stringForSystemPartAndValueType(pair.systempart, pair.valuetype)
        : this.stringForSystemPartAndValueType(-1, -1) // Strom ohne jeden anzeigbaren Wert, wie bisher
    },
    totalSensorSystemDisplay (sensor) {
      return this.stringForSystemPartAndValueType(sensor.total.systempart, sensor.total.valuetypetotal)
    },
    stringForSystemPartAndValueType (systempart, valuetype) {
      if (systempart && valuetype) {
        const systemPartText = this.attributeLabelForCode('systemPart', systempart)
        const valueTypeText = this.attributeLabelForCode('valueType', valuetype)
        return systemPartText + ' ' + valueTypeText
      }
      return ''
    },
    manipulatedUnitDisplay (valuetype, prefix) {
      if (valuetype) {
        return prefix + this.attributeLabelForCode('physicalUnit', valuetype)
      }
      return ''
    },
    unitDisplay (valueObject) {
      if (valueObject) {
        const prefix = this.computeNumericValue(valueObject) > Math.pow(10, 6) ? 'k' : ''

        if (valueObject.type === 31) {
          // show only Sensor Code label when there is a code
          return valueObject.factor > 0 ? this.manipulatedUnitDisplay(valueObject.type, '') : ''
        } else if (valueObject.type === 32 || valueObject.type === 33) {
          // no prefix for certain value types
          return this.manipulatedUnitDisplay(valueObject.type, '')
        }

        return this.manipulatedUnitDisplay(valueObject.type, prefix)
      }
      return ''
    },
    sensorUnitDisplay (sensor) {
      let valueEntry = this.findFirstGlanceReading(sensor)
      if (!valueEntry) {
        // fallback for electricity?
        if (sensor.type === 0) {
          const values = this.findFallbackMeasurementsForElectricityFirstGlanceReading(sensor)
          if (values && values.length > 0) {
            valueEntry = values[0]
          } else {
            valueEntry = this.findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReading(sensor)
            if (!valueEntry) {
              valueEntry = this.findFallbackMeterReadingMeasurementsForElectricityFirstGlanceReading(sensor)
            }
          }
        } else if (sensor.type === 1) { // Gas
          valueEntry = 13 // CDC_M3_MINUTE_TYPE
          return this.manipulatedUnitDisplay(valueEntry, '')
        } else if (sensor.type === 2) { // Water
          valueEntry = 26 // CDC_L_MIN_TYPE
          return this.manipulatedUnitDisplay(valueEntry, '')
        }
      }
      return this.unitDisplay(valueEntry)
    },
    totalSensorUnitDisplay (sensor) {
      const prefix = this.computeNumericValue(sensor.total) > Math.pow(10, 6) ? 'k' : ''
      return this.manipulatedUnitDisplay(sensor.total.valuetypetotal, prefix)
    },
    formattedValue (valueEntry, valueType) {
      if (valueType !== 31 && valueType !== 32 && valueType !== 33) {
        let value = this.computeNumericValue(valueEntry)
        const decimals = (valueType === 13 || valueType === 14) ? 3 : 1
        if (value > Math.pow(10, 6)) {
          value /= 1000.0
        }
        value = value.toFixed(decimals)
        return parseFloat(value).toLocaleString(navigator.language)
      } else {
        if (valueType === 31) { // Sensor CDC_ALERT_TYPE
          const alertTypeNames = ['UNBEKANNT', 'NORMAL', 'TEST', 'INFO', 'NOTICE', 'WARNING', 'ERROR', 'CRITICAL', 'EMERGENCY']
          const sensorAlertCode = valueEntry.value // this.computeNumericValue(valueEntry))
          const code = Number(valueEntry.factor & 0xff)

          const index = sensorAlertCode < 7 ? sensorAlertCode : 0
          return alertTypeNames[index] + (code > 0 ? ' (' + code + ') ' : '')
        }
        return parseFloat(valueEntry.value).toLocaleString(navigator.language)
      }
    },
    sensorValueDisplay (sensor) {
      let valueEntry = this.findFirstGlanceReading(sensor)

      if (valueEntry) {
        return this.formattedValue(valueEntry, valueEntry.type)
      } else {
        const valueObjects = this.findFallbackMeasurementsForElectricityFirstGlanceReading(sensor)

        if (valueObjects && valueObjects.length > 0) {
          // const first = valueObjects[0]
          let sum = 0.0
          let hasSum = false
          let total = 0.0
          for (const valueObject of valueObjects) {
            if (valueObject.type === 3) {
              sum = sum + this.computeNumericValue(valueObject)
              hasSum = true
            } else if (valueObject.type === 4) {
              total = this.computeNumericValue(valueObject)
            }
          }
          return this.formattedValue({ value: hasSum ? sum : total, factor: 0 }, hasSum ? 3 : 4) // first.type)
        } else {
          valueEntry = this.findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReading(sensor)
          // fallback single phase
          if (valueEntry) {
            return this.formattedValue(valueEntry, valueEntry.type)
          }
          // fallback meter reading
          valueEntry = this.findFallbackMeterReadingMeasurementsForElectricityFirstGlanceReading(sensor)
          if (valueEntry) {
            return this.formattedValue(valueEntry, valueEntry.type)
          }
        }
      }
      return '?'
    },
    totalSensorValueDisplay (sensor) {
      return this.formattedValue(sensor.total, sensor.total.valuetypetotal)
    },
    totalSensorAccuracyDisplay (sensor) {
      if (sensor && sensor.total) {
        const packagecount = sensor.total.packagecount
        const missedpackages = sensor.total.missedpackages
        const ratio = packagecount > 0 ? missedpackages / (packagecount + missedpackages) * 100.0 : 100.0
        return ratio.toFixed(1)
      }
      return '?'
    },
    sensorHasTotal (sensor) {
      return sensor && sensor.total
    },
    sensorHasTotalSinceStart (sensor) {
      return sensor && sensor.total && sensor.total.systempart === 26
    },
    isVirtualSensor (sensor) {
      if (!sensor) return false
      // Robust detection: prefer the structural connector flag (6 = CDC_C_VIRTUAL,
      // set server-side at creation), fall back to model for older payloads where
      // connector was not exposed.
      if (sensor.connector === 6) return true
      return sensor.model === 'CS_Virtual'
    },
    // Computed sensors are virtual sensors too (isVirtualSensor stays true —
    // that keeps the virtual firstGlance pair), but they get a chart, no
    // manual value entry and no meter swap.
    isComputedSensor (sensor) {
      return computedSensors.isComputedSensor(sensor)
    },
    computedFormulaDisplay (sensor) {
      const members = computedSensors.computedMembers(sensor)
      if (!members) return ''
      return computedSensors.formulaString(members, (id) => {
        if (!this.currentFacility || !this.currentFacility.devices) return null
        for (const device of this.currentFacility.devices) {
          for (const candidate of (device.sensors || [])) {
            if (Number(candidate.id) === Number(id)) return candidate.name
          }
        }
        return null
      }, (sp) => this.attributeLabelForCode('systemPart', sp))
    },
    openVirtualValueModal () {
      this.virtualModalTimestamp = new Date().toISOString()
      const el = document.querySelector('#addVirtualSensorValueModal')
      const { Modal } = require('bootstrap')
      Modal.getOrCreateInstance(el, { backdrop: 'static' }).show()
    },
    modalClosedVirtual () {
      this.loadLatestCDCDataValues()
    },
    manualMeterReading (sensor) {
      this.openModal('#editSensorTotalModal')
    },
    // private
    computeNumericValue (sensorValue) {
      if (sensorValue) {
        return sensorValue.value * Math.pow(10, sensorValue.factor)
      }
      return 0.0
    },
    // data for graph
    loadDataValues () {
      this.isLoading = true
      this.chartDataLoading = true
      const startTS = moment(this.chartStartDate).valueOf()
      const endTS = moment(this.chartEndDate).valueOf()
      const payload = { cdcDeviceId: this.currentDevice.id, fromDate: startTS, untilDate: endTS }
      this.$store.commit('clearError')
      this.$store.dispatch('getCDCDataValuesSlim', payload)
      this.loadObservations()
    },
    chartOptions () {
      let radius = 0
      let borderWidth = 1
      if (this.chartDuration <= 1) {
        radius = 2
        borderWidth = 2
      }
      const options = {
        colors: ['#008FFB', '#00E396', '#CED4DC'],
        fill: {
          target: 'origin',
          above: 'rgba(71, 183,132,.1)',
          below: 'rgba(71, 183,132,.1)'
        },
        elements: {
          point: {
            radius
          },
          line: {
            borderWidth
          }
        },
        scales: {
          x: {
            type: 'time',
            offset: true,
            gridLines: { offsetGridLines: true },
            time: { displayFormats: { minute: 'HH:mm' } },
            ticks: {
              display: false // this will remove only the label
            },
            display: true
          }
        }
      }
      // chart observations: click-to-annotate (caretaker/admin) + tooltip lines.
      // Chartkick merges `library` into the Chart.js options, so callbacks
      // belong here; the chart is rebuilt on every re-render, closures stay fresh.
      if (this.userMayEdit && this.supportsChartClick) {
        options.onClick = (event, elements, chart) => this.onChartPointClick(elements, chart)
        options.onHover = (event, elements, chart) => {
          const hit = chartObservations.pickClickedElement(elements, chart.data.datasets)
          const target = event && event.native ? event.native.target : null
          if (target) target.style.cursor = hit ? 'pointer' : 'default'
        }
      }
      options.plugins = {
        tooltip: {
          callbacks: {
            afterBody: (items) => this.observationTooltipLines(items)
          }
        }
      }
      return options
    },
    barChartOptions () {
      return {
        scales: {
          x: {
            type: 'category',
            offset: true,
            gridLines: { offsetGridLines: true },
            ticks: { display: true },
            display: true
          }
        }
      }
    },
    barChartDataSet () {
      // TODO: implement preferences
      const preferences = this.client.preferences
      let backgroundColor = 'rgba(102,129,194,.5)'
      const borderColor = 'rgba(102,129,194,1)' // '#6695C2'
      let borderWidth = 2
      if (preferences.barBackgroundColor) {
        backgroundColor = preferences.barBackgroundColor
      }
      if (preferences.barborderWidth) {
        borderWidth = preferences.barborderWidth
      }
      if (preferences.barBorderWidth) {
        borderWidth = preferences.barBorderWidth
      }
      const dataset = {
        backgroundColor,
        borderColor,
        borderWidth,
        borderRadius: 5
        // barPercentage: 0.5,
        // barThickness: 6,
        // maxBarThickness: 8
      }
      return dataset
    },
    // chartjs
    color: function (context) {
      const index = context.dataIndex
      const value = context.dataset.data[index]
      return value < 0 ? 'red' : index % 2 ? 'blue' : 'green'
    },
    // chartjs
    /*
    borderColor: function (context, options) {
      const color = options.color // resolve the value of another scriptable option: 'red', 'blue' or 'green'
      return Chart.helpers.color(color).lighten(0.2)
    },
    */
    areaChartDataSet () {
      const preferences = this.client.preferences

      let borderWidth = 2
      // var backgroundColor = 'rgba(102,129,194,.5)'
      // var borderColor = 'rgba(102,129,194,1)' // '#6695C2'
      // if (preferences.areaBackgroundColor) {
      // backgroundColor = preferences.areaBackgroundColor
      // }
      // if (preferences.areaBorderColor) {
      // borderColor = preferences.areaBorderColor
      // }
      if (preferences.areaBorderWidth) {
        if (this.chartDuration > 1) {
          borderWidth = 1
        } else {
          borderWidth = preferences.areaBorderWidth
        }
      }
      const dataset = {
        // backgroundColor: backgroundColor,
        // borderColor: 'green', // borderColor,
        borderWidth
      }
      return dataset
    },
    statsDataSets (sensor) {
      const dataSets = []
      if (this.sensorAggregations.aggregations && this.sensorAggregations.aggregations.length > 0) {
        const aDataPackackage = this.sensorAggregations.aggregations[0]
        const dataExp = this.aggregationsData('exp')
        const dataImp = this.aggregationsData('imp')

        const preferences = this.client.preferences
        let backgroundColor = 'rgba(102,129,194,.5)'
        const borderColor = 'rgba(102,129,194,1)' // '#6695C2'
        let borderWidth = 2
        if (preferences.barBackgroundColor) {
          backgroundColor = preferences.barBackgroundColor
        }
        if (preferences.barborderWidth) {
          borderWidth = preferences.barborderWidth
        }
        if (preferences.barBorderWidth) {
          borderWidth = preferences.barBorderWidth
        }

        let hasValues = false
        if (dataExp && Object.keys(dataExp).length > 0) {
          const prefix = aDataPackackage.dailyexpvt === 10 ? 'k' : '' // 9 and 10 will be in aggregationsData changed to kWh
          const graph = {
            type: 'bar',
            name: this.stringForSystemPartAndValueType(aDataPackackage.dailyexpsp, aDataPackackage.dailyexpvt) + ' (' + this.manipulatedUnitDisplay(aDataPackackage.dailyexpvt, prefix) + ')', // 'Export', // title,
            backgroundColor, // 'rgba(F3, A6, 93,.5)',
            borderColor, // '#F3A693',
            borderWidth,
            data: dataExp
          }
          hasValues = true
          dataSets.push(graph)
        }
        if (dataImp && Object.keys(dataImp).length > 0) {
          const prefix = aDataPackackage.dailyimpvt === 9 ? 'k' : '' // 9 and 10 will be in aggregationsData changed to kWh
          const graph = {
            type: 'bar',
            name: this.stringForSystemPartAndValueType(aDataPackackage.dailyimpsp, aDataPackackage.dailyimpvt) + ' (' + this.manipulatedUnitDisplay(aDataPackackage.dailyimpvt, prefix) + ')', // 'Import', // title,
            backgroundColor, // 'rgba(F3, A6, 93,.5)',
            borderColor, // '#F3A693',
            borderWidth: 5, // borderWidth,
            data: dataImp
          }
          hasValues = true
          dataSets.push(graph)
        }
        if (!hasValues) { // if there is no Import / Export value use min, max, avg
          const dataMin = this.aggregationsData('min')
          const dataMax = this.aggregationsData('max')
          const dataAvg = this.aggregationsData('avg')

          if (dataMin && Object.keys(dataMin).length > 0) {
            const graph = {
              type: 'bar',
              name: 'Min.' + this.stringForSystemPartAndValueType(aDataPackackage.systempart, aDataPackackage.valuetype), // 'Import', // title,
              backgroundColor, // 'rgba(F3, A6, 93,.5)',
              borderColor, // '#F3A693',
              borderWidth,
              data: dataMin
            }
            dataSets.push(graph)
          }
          if (dataMax && Object.keys(dataMax).length > 0) {
            const graph = {
              type: 'bar',
              name: 'Max.' + this.stringForSystemPartAndValueType(aDataPackackage.systempart, aDataPackackage.valuetype), // 'Import', // title,
              backgroundColor, // 'rgba(F3, A6, 93,.5)',
              borderColor, // '#F3A693',
              borderWidth,
              data: dataMax
            }
            dataSets.push(graph)
          }
          if (dataAvg && Object.keys(dataAvg).length > 0) {
            const graph = {
              type: 'bar',
              name: 'Avg.' + this.stringForSystemPartAndValueType(aDataPackackage.systempart, aDataPackackage.valuetype), // 'Import', // title,
              backgroundColor, // 'rgba(F3, A6, 93,.5)',
              borderColor, // '#F3A693',
              borderWidth,
              data: dataAvg
            }
            dataSets.push(graph)
          }
        }
      }
      return dataSets
    },
    chartDataSets (sensor) {
      const dataSet = []
      this.selectedCharts.forEach(chartSet => {
        const data = this.currentData(sensor, chartSet.value.systempart, chartSet.value.valuetype)

        // const title = this.sensorSystemDisplay(sensor) + ' (' + this.sensorUnitDisplay(sensor) + ')'
        const title = this.stringForSystemPartAndValueType(chartSet.value.systempart, chartSet.value.valuetype) + ' (' + this.manipulatedUnitDisplay(chartSet.value.valuetype, '') + ')'
        const labels = []
        /*
        for (const key of Object.keys(data)) {
          const date = new Date(key)
          labels.push(moment(date).format('HH:mm'))
        }
        */

        if (data && Object.keys(data).length > 0) {
          let graph
          if (sensor.type !== 1 && sensor.type !== 2) {
            graph = {
              type: 'line',
              name: title,
              backgroundColor: 'rgba(chartSet.value.systempart * 10, 183, 132, 0.5)',
              borderColor: 'red', // '#47b784',
              data,
              labels,
              dataset: this.observationPointOptions(chartSet.value.systempart, chartSet.value.valuetype),
              options: {
                legend: { display: false },
                scales: {
                  x: {
                    type: 'time',
                    offset: true,
                    gridLines: { offsetGridLines: true },
                    time: { displayFormats: { minute: 'HH:mm' } },
                    ticks: {
                      display: false // this will remove only the label
                    },
                    display: true
                  },
                  y: {
                    display: true,
                    type: 'linear',
                    position: 'left',
                    title: {
                      display: true,
                      text: this.manipulatedUnitDisplay(chartSet.value.valuetype, ''),
                      color: '#191',
                      font: {
                        family: 'Times',
                        size: 20,
                        style: 'normal',
                        lineHeight: 1.2
                      },
                      padding: { top: 30, left: 0, right: 0, bottom: 0 }
                    }
                  },
                  y1: {
                    display: true,
                    type: 'linear',
                    position: 'right',
                    title: {
                      display: true,
                      text: this.manipulatedUnitDisplay(chartSet.value.valuetype, ''),
                      color: '#191',
                      font: {
                        family: 'Times',
                        size: 20,
                        style: 'normal',
                        lineHeight: 1.2
                      },
                      padding: { top: 30, left: 0, right: 0, bottom: 0 }
                    }
                  }
                }
              }
            }
          } else {
            graph = {
              type: 'bar',
              name: title,
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 2,
              data,
              labels,
              options: {
                legend: { display: true },
                scales: {
                  x: {
                    type: 'time',
                    offset: true,
                    gridLines: { offsetGridLines: true },
                    time: { displayFormats: { minute: 'HH:mm' } },
                    ticks: {
                      display: false // this will remove only the label
                    },
                    display: true
                  }
                }
              }
            }
          }
          dataSet.push(graph)
          // send-on-change sensors: dashed pale carry-forward of the last
          // value up to "now" (unconfirmed prediction). Chartkick merges the
          // per-series `dataset` options last, so this styling always wins.
          if (sensor.type !== 1 && sensor.type !== 2) {
            const prediction = this.predictionData(sensor, chartSet.value.systempart, chartSet.value.valuetype)
            if (Object.keys(prediction).length > 1) {
              dataSet.push({
                name: title + ' (' + this.$t('homePage.predictionSuffix') + ')',
                data: prediction,
                dataset: {
                  frmMeta: { systempart: chartSet.value.systempart, valuetype: chartSet.value.valuetype, isPrediction: true },
                  borderDash: [6, 4],
                  borderColor: 'rgba(0, 143, 251, 0.45)',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                  fill: false,
                  pointRadius: 0,
                  pointHoverRadius: 0,
                  tension: 0
                }
              })
            }
          }
        }
      })
      return dataSet
    },
    // : [ { "text": "Versorgung Spannung", "value": { "systempart": 10, "valuetype": 1 } }, { "text": "Temperatur 1 Grad", "value": { "systempart": 20, "valuetype": 16 } }, { "text": "RSSI dBM", "value": { "systempart": 24, "valuetype": 23 } } ]
    avalableValuetypes () {
      const sensorpk = this.currentSensor.originalid

      const filtered = this.cdcdatavalues.filter(item => item.sensorpk === sensorpk)

      // all "values"-Arrays flatten; vt:36 (no-change count) is transport
      // metadata, not a chartable series
      const allValues = filtered.flatMap(item => item.values).filter(v => v.type !== 36)
      // const allValues = this.cdcdatavalues.flatMap(item => item.values)

      // extract systempart and type
      const combinations = allValues.map(v => ({
        text: this.stringForSystemPartAndValueType(v.systempart, v.type),
        value: { systempart: v.systempart, valuetype: v.type }
      }))

      // remove dups
      const uniqueCombinations = Array.from(
        new Map(combinations.map(obj => [`${obj.text}-${obj.value}`, obj])).values()
      )
      // sort by name
      uniqueCombinations.sort((a, b) => a.text.localeCompare(b.text))
      return uniqueCombinations
    },
    currentData (sensor, systempart, valuetype) {
      /*
      if (this.selectedCharts.length > 0) {
        const pair = this.selectedCharts[0].value
        return this.firstGlanceData(sensor, pair.systempart, pair.valuetype)
      }

      return this.firstGlanceData(sensor)
      */
      return this.firstGlanceData(sensor, systempart, valuetype)
    },
    firstGlanceData (sensor, systempart, valuetype) { // private func
      if (this.cachedData[sensor.id + systempart + valuetype]) {
        return this.cachedData[sensor.id + systempart + valuetype]
      }
      const data = {}
      let lastTS = moment()
      // previous package of this series — anchor for the vt:36 backfill
      // (the suppressed minutes carried the PREVIOUS value, not the new one)
      let prevMeasurement = null
      let prevStamp = null
      // label -> {iso, value, synthetic} map for chart observations (click resolution + delta)
      const points = chartObservations.createSeriesPoints()
      this.cdcDataSortedByTime.forEach(dataPackage => {
        // select values for this sensor only!
        if (sensor.originalid === dataPackage.sensorpk) {
          let measurement = 0.0
          // Whether this package actually carries the requested value. Not every
          // package does: the members of a batched transmission only carry the
          // meter values (the RSSI belongs to the reception, so it sits on the
          // newest member only), and the battery voltage now arrives once an
          // hour with the aux values. Writing 0.0 for those would invent
          // readings — see the guard below.
          let hasMeasurement = false
          let value
          /* eslint-disable no-console */
          // console.log('systempart: ' + systempart + ' valuetype: ' + valuetype)
          if (systempart == null || valuetype == null) {
            value = this.findFirstGlanceReadingInDataPackage(sensor, dataPackage)
          } else {
            value = this.findSensorValueForSystemPartAndType(sensor, { systempart, valuetype }, dataPackage)
          }
          const zeros = this.findSensorValueForSystemPartAndType(sensor, { systempart: 4, valuetype: 18 }, dataPackage)

          // if there where zero counts add them here
          if (zeros) {
            const zeroCount = this.computeNumericValue(zeros)
            for (let i = 1; i <= zeroCount; i++) {
              const stamp = moment(String(this.effectiveTime(dataPackage))).subtract(i, 'minutes')
              points.addSynthetic(stamp.format('H:mm'), stamp.toISOString(), 0)
              if (sensor.type === 1 || sensor.type === 2) {
                data[stamp.format('H:mm')] = 0
              } else {
                data[stamp] = 0
              }
            }
          }
          if (value) {
            measurement = this.computeNumericValue(value)
            hasMeasurement = true
          } else {
            const values = this.findFallbackMeasurementsForElectricityFirstGlanceReadingInDataPackage(sensor, dataPackage)
            if (values && values.length > 0) {
              for (const value of values) {
                measurement += this.computeNumericValue(value)
              }
              hasMeasurement = true
            } else {
              const value = this.findSinglePhaseFallbackMeasurementsForElectricityFirstGlanceReadingInDataPackage(sensor, dataPackage)
              if (value) {
                measurement = this.computeNumericValue(value)
                hasMeasurement = true
              }
            }
          }
          // No value for this series in this package = no reading for that
          // minute, so no point at all. Impulse counters (bar charts) are the
          // exception: there "nothing happened" IS a real zero, and the code
          // below deliberately fills those.
          const isBarChartSensor = sensor.type === 1 || sensor.type === 2
          if (!hasMeasurement && !isBarChartSensor) {
            return
          }
          // the measurement time, so the members of a batched packet land on
          // their own minute instead of overwriting each other
          const stamp = moment(String(this.effectiveTime(dataPackage)))
          // send-on-change (CS-* v5): a vt:36 tuple confirms the previous
          // value was valid for the suppressed minutes — backfill them
          // BEFORE writing the current point so the real point wins.
          const noChange = this.findSensorValueForSystemPartAndType(sensor, { systempart: 4, valuetype: 36 }, dataPackage)
          if (noChange) {
            sendOnChangeSeen[sensor.id] = true
            if (sensor.type !== 1 && sensor.type !== 2) {
              const filled = sendOnChange.backfillNoChange(data, this.computeNumericValue(noChange), prevMeasurement, prevStamp, stamp)
              points.addSyntheticRange(stamp, filled, prevMeasurement)
            }
          }
          data[stamp.format('H:mm')] = measurement
          points.addReal(stamp.format('H:mm'), stamp.toISOString(), measurement, dataPackage.id)
          /*
          if (sensor.type === 1 || sensor.type === 2) {
            data[stamp.format('HH:mm')] = measurement
          } else {
            data[stamp] = measurement
          }
          */
          lastTS = stamp
          prevMeasurement = measurement
          prevStamp = stamp
        }
      })
      // add zeros to the end when barchart
      if (sensor.type === 1 || sensor.type === 2) {
        let end = moment(this.chartEndDate)
        if (new Date(this.chartEndDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0) && this.chartDuration > 1) {
          // is today and 24h display set new Date to have the current time as end
          end = moment(new Date())
        }
        const diffMinutes = end.diff(lastTS, 'minutes')
        for (let minutes = 1; minutes <= diffMinutes; minutes++) {
          const currentTS = lastTS.clone().add(minutes, 'minutes')
          data[currentTS.format('H:mm')] = 0
          points.addSynthetic(currentTS.format('H:mm'), currentTS.toISOString(), 0)
        }
      }
      this.cachedData[sensor.id + systempart + valuetype] = data
      // anchor for the dashed prediction of send-on-change sensors
      this.cachedMeta[sensor.id + systempart + valuetype] = { lastStamp: prevStamp, lastMeasurement: prevMeasurement, points: points.build() }
      return data
    },
    // Unconfirmed carry-forward of the last value for send-on-change sensors
    // ("prediction", rendered as a dashed pale series). Only while viewing
    // "now" — historic windows get the confirmed vt:36 backfill instead.
    predictionData (sensor, systempart, valuetype) {
      if (sensor.type === 1 || sensor.type === 2) return {}
      if (!this.isViewingCurrentTime()) return {}
      if (!this.sensorIsSendOnChange(sensor)) return {}
      // ensure the meta anchor exists (currentData fills the cache)
      this.currentData(sensor, systempart, valuetype)
      const meta = this.cachedMeta[sensor.id + systempart + valuetype]
      if (!meta) return {}
      return sendOnChange.buildPrediction(meta.lastStamp, meta.lastMeasurement, new Date())
    },
    aggregationsData (key) { // private func
      const data = {}
      if (this.sensorAggregations.aggregations) {
        this.sensorAggregations.aggregations.forEach(dataPackage => {
          let measurement
          if (key === 'exp') {
            measurement = dataPackage.dailyexp
          } else if (key === 'max') {
            measurement = dataPackage.max
          } else if (key === 'min') {
            measurement = dataPackage.min
          } else if (key === 'avg') {
            measurement = dataPackage.sum / dataPackage.cnt
          } else {
            measurement = dataPackage.dailyimp
          }
          if (measurement) {
            const stamp = moment(String(dataPackage.date))
            const factor = dataPackage.dailyimpvt === 9 || dataPackage.dailyexpvt === 10 ? -3 : 0 // 4,9 is in Wh make it kWh
            if (factor === -3 && measurement > 25000) {
              data[stamp.format('MMM Do YY')] = Math.round(measurement * Math.pow(10, factor))
            } else {
              const num = Number(measurement * Math.pow(10, factor))
              const roundedString = num.toFixed(2)
              data[stamp.format('MMM Do YY')] = Number(roundedString)
            }
          }
        })
      }
      return data
    },
    showMapSnapshot (facility) {
      if (facility != null) {
        this.setMapFacility(facility)
      }
      this.openModal('#mapSnapshotModal')
    },
    loadDetailedFacilities (reset) {
      // Facility list for maps/pickers only. The store action getFacilityData
      // would also replace state.organizations with the admin list (no
      // `facilities` on it) and blank the monitoring view until the next
      // latestdata response — on login that was the whole latestdata wait.
      this.$store.commit('clearError')
      facilityService.getFacilityData(this.selectedOrganization.id).then((data) => {
        this.$store.commit('updateFacilityList', data)
      }).catch((error) => {
        this.$store.commit('updateErrorMessage', { flag: true, origin: 'getFacilityData', message: error.message })
      })
    },
    openInAppleMap (facility) {
      window.open(this.createMapLink(facility), '_blank')
    },
    hasCoordinates (facility) {
      this.setMapFacility(facility)
      if (this.showMapFacility && this.showMapFacility.geolatitude && this.showMapFacility.geolongitude) {
        return true
      }
      return false
    },
    createMapLink (facility) {
      this.setMapFacility(facility)
      if (this.showMapFacility && this.showMapFacility.geolatitude && this.showMapFacility.geolongitude) {
        const uri = 'https://beta.maps.apple.com/?ll=' + this.showMapFacility.geolatitude + ',' + this.showMapFacility.geolongitude + '&q=' + this.showMapFacility.name
        return encodeURI(uri)
        // return 'maps://q=' + this.showMapFacility.geolatitude + ',' + this.showMapFacility.geolongitude
      }
      return ''
    },
    setMapFacility (aFacility) {
      if (aFacility != null) {
        this.facilities.forEach(facility => {
          //  update current selected facility
          if (facility.id === aFacility.id) { // this.currentFacility.id) {
            this.showMapFacility = facility
          }
        })
      }
    },
    // ---- Verbraucher + Chart-Beobachtungen ----------------------------
    //
    // The chart is a Chartkick category axis with 'H:mm' labels: a click
    // yields the label of the point, which the meta map built in
    // firstGlanceData (cachedMeta[...].points) resolves to timestamp,
    // value and the previous real point. Prediction and synthetic
    // (backfill / zero) points are ignored.
    onChartPointClick (elements, chart) {
      if (!this.userMayEdit || !this.supportsChartClick) return
      const hit = chartObservations.pickClickedElement(elements, chart.data.datasets)
      if (!hit) return
      const label = chart.data.labels[hit.element.index]
      const key = chartObservations.seriesKey(hit.meta.systempart, hit.meta.valuetype)
      const existing = (this.observationIndex[key] || {})[label]
      if (existing) {
        this.openEditObservation(existing)
        return
      }
      const meta = this.cachedMeta[this.currentSensor.id + hit.meta.systempart + hit.meta.valuetype]
      const proposal = chartObservations.proposeObservation(meta ? meta.points : null, label, hit.meta)
      if (!proposal) return
      this.openAddObservation(proposal)
    },
    // scriptable per-point options: annotated points are drawn as a
    // coloured diamond (also in the day view, where plain points have radius 0)
    observationPointOptions (systempart, valuetype) {
      const index = this.observationIndex[chartObservations.seriesKey(systempart, valuetype)] || {}
      const base = this.chartDuration <= 1 ? 2 : 0
      const obsAt = ctx => index[ctx.chart.data.labels[ctx.dataIndex]]
      return {
        frmMeta: { systempart, valuetype, isPrediction: false },
        pointRadius: ctx => obsAt(ctx) ? 5 : base,
        pointHoverRadius: ctx => obsAt(ctx) ? 7 : base + 2,
        pointStyle: ctx => obsAt(ctx) ? 'rectRot' : 'circle',
        pointBackgroundColor: ctx => {
          const o = obsAt(ctx)
          return o ? chartObservations.kindColor(o.kind) : ctx.dataset.borderColor
        },
        pointBorderColor: ctx => obsAt(ctx) ? '#333' : ctx.dataset.borderColor,
        pointBorderWidth: ctx => obsAt(ctx) ? 2 : 1
      }
    },
    observationTooltipLines (items) {
      const lines = []
      for (const item of items || []) {
        const meta = item.dataset ? item.dataset.frmMeta : null
        if (!meta || meta.isPrediction) continue
        const o = (this.observationIndex[chartObservations.seriesKey(meta.systempart, meta.valuetype)] || {})[item.label]
        if (!o) continue
        const parts = []
        if (o.applianceName) parts.push(o.applianceName)
        parts.push(this.$t('observationKind.' + o.kind))
        const delta = chartObservations.formatDelta(o.delta, this.manipulatedUnitDisplay(o.valuetype, ''))
        if (delta) parts.push(delta)
        lines.push(parts.join(' · '))
      }
      return lines
    },
    observationTimeDisplay (observation) {
      const fmt = this.chartDuration <= 1 ? 'HH:mm' : 'DD.MM. HH:mm'
      return moment(observation.observedat).format(fmt)
    },
    formatDelta (delta, unit) {
      return chartObservations.formatDelta(delta, unit)
    },
    kindBadgeClass (kind) {
      return chartObservations.kindBadgeClass(kind)
    },
    applianceIcon (appliance) {
      return applianceUtils.faIconForAppliance(appliance)
    },
    loadObservations () {
      if (!this.currentSensor || this.currentSensor.id < 0) {
        this.observations = []
        return
      }
      const sensorId = this.currentSensor.id
      const from = moment(this.chartStartDate).valueOf()
      const until = moment(this.chartEndDate).valueOf()
      this.observationsLoading = true
      observationsService.listForSensor(sensorId, from, until).then((data) => {
        if (this.currentSensor && this.currentSensor.id === sensorId) {
          this.observations = (data && data.observations) || []
        }
      }).catch(() => {
        // the list is an annotation layer — a failed load must not break the chart
      }).finally(() => {
        this.observationsLoading = false
      })
    },
    loadAppliances () {
      if (!this.currentFacility || this.currentFacility.id == null) {
        this.appliances = []
        return
      }
      const facilityId = this.currentFacility.id
      appliancesService.listForFacility(facilityId).then((data) => {
        if (this.currentFacility && this.currentFacility.id === facilityId) {
          this.appliances = (data && data.appliances) || []
        }
      }).catch(() => {
        this.appliances = []
      })
    },
    openAddObservation (proposal) {
      this.observationToEdit = null
      this.observationProposal = proposal
      this.observationModalAction = 'add'
      this.observationModalTimestamp = new Date().toISOString()
      this.showEditModal('#observationModal')
    },
    openEditObservation (observation) {
      this.observationProposal = null
      this.observationToEdit = observation
      this.observationModalAction = 'edit'
      this.observationModalTimestamp = new Date().toISOString()
      this.showEditModal('#observationModal')
    },
    modalClosedObservation (anyChanges) {
      this.modalViewVisible = false
      if (anyChanges) {
        this.loadObservations()
      }
    },
    applianceModalPointsFor (extraSystempart) {
      const parts = this.applianceTileSystemParts.slice()
      if (extraSystempart != null && !parts.includes(Number(extraSystempart))) {
        parts.push(Number(extraSystempart))
      }
      parts.sort((a, b) => a - b)
      return parts.map(sp => ({ systempart: sp, label: this.attributeLabelForCode('systemPart', sp) }))
    },
    openAddAppliance (preselectSystempart) {
      this.applianceToEdit = null
      this.applianceModalAction = 'add'
      this.applianceModalPoints = this.applianceModalPointsFor(preselectSystempart)
      this.applianceModalPreselect = preselectSystempart != null ? Number(preselectSystempart) : null
      this.applianceModalTimestamp = new Date().toISOString()
      this.showEditModal('#editApplianceModal')
    },
    openEditAppliance (appliance) {
      this.applianceToEdit = appliance
      this.applianceModalAction = 'edit'
      this.applianceModalPoints = this.applianceModalPointsFor(null)
      this.applianceModalPreselect = null
      this.applianceModalTimestamp = new Date().toISOString()
      this.showEditModal('#editApplianceModal')
    },
    // "neu anlegen…" inside the observation modal: remember the proposal,
    // open the appliance modal with the clicked systempart ticked and come
    // back to the observation with the new appliance preselected
    createApplianceFromObservation (payload) {
      this.pendingObservationProposal = this.observationProposal
        ? Object.assign({}, this.observationProposal)
        : (this.observationToEdit ? { editing: this.observationToEdit } : null)
      this.modalViewVisible = false
      this.openAddAppliance(payload ? payload.systempart : null)
    },
    modalClosedAppliance (anyChanges, savedAppliance) {
      this.modalViewVisible = false
      const pending = this.pendingObservationProposal
      this.pendingObservationProposal = null
      if (anyChanges) {
        this.loadAppliances()
      }
      if (!pending) return
      const preselect = savedAppliance && savedAppliance.id != null ? { applianceid: savedAppliance.id } : {}
      // let the bootstrap fade of the appliance modal finish first
      setTimeout(() => {
        if (pending.editing) {
          this.openEditObservation(Object.assign({}, pending.editing, preselect))
        } else {
          this.openAddObservation(Object.assign({}, pending, preselect))
        }
      }, 350)
    },
    askDeleteObservation (observation) {
      this.pendingDelete = { type: 'observation', id: observation.id }
      this.showEditModal('#confirmModal')
    },
    askDeleteAppliance (appliance) {
      if (!appliance) return
      this.pendingDelete = { type: 'appliance', id: appliance.id, name: appliance.name }
      setTimeout(() => this.showEditModal('#confirmModal'), 350)
    },
    confirmDeleteAction () {
      const pending = this.pendingDelete
      this.pendingDelete = null
      if (!pending) return
      const request = pending.type === 'appliance'
        ? appliancesService.deleteAppliance(pending.id).then(() => {
          this.loadAppliances()
          this.loadObservations()
        })
        : observationsService.deleteObservation(pending.id).then(() => this.loadObservations())
      request.catch(error => {
        this.errorMessage = this.localizedBackendMessage(error.message)
      })
    },
    toggleChartDuration () {
      if (this.chartDuration <= 1) {
        this.chartDuration = 24
      } else {
        this.chartDuration = 1
      }
    },
    toggleStatsDuration () {
      if (this.statsDuration <= 7) {
        this.statsDuration = 31
      } else {
        this.statsDuration = 7
      }
    },
    previousChart () {
      if (this.chartViewStatus === 2) {
        this.selectedChartDate = moment(this.selectedChartDate).subtract(this.statsDuration, 'days').toDate()
      } else {
        this.selectedChartDate = moment(this.selectedChartDate).subtract(this.chartDuration, 'hours').toDate()
      }
    },
    nextChart () {
      let newChartDate // = moment(this.selectedChartDate).add(this.chartDuration, 'hours').toDate()
      if (this.chartViewStatus === 2) {
        newChartDate = moment(this.selectedChartDate).add(this.statsDuration, 'days').toDate()
      } else {
        newChartDate = moment(this.selectedChartDate).add(this.chartDuration, 'hours').toDate()
      }
      if (newChartDate > new Date()) {
        this.selectedChartDate = new Date()
      } else {
        this.selectedChartDate = newChartDate
      }
    },
    toggleShowChartOptions () {
      this.showChartOptions = !this.showChartOptions
    },
    toggleChartView () {
      if (this.chartViewStatus === 1) {
        this.chartViewStatus = 2
      } else {
        this.chartViewStatus = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.report-locked {
  color: #aaa !important;
  cursor: default !important;
  pointer-events: auto;

  &:hover { background-color: transparent !important; }
}

.lock-icon {
  margin-left: 6px;
  font-size: 0.75em;
  color: #bbb;
}

.content-container {
  padding: 0 35px;
  /* height: 400px; */

  h2 {
    font-size: 18px;
    margin-bottom: 15px;
    font-weight: 400;
  }
  .main-title {

  }

  .main-section {
    margin: 30px 10px;
    background: none;
    padding: 5px;
    z-index: 20;
  }

  .main-section {position:-webkit-sticky; position:sticky; top:0;}

  .facility-wrapper {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    column-gap: 10px;
    row-gap: 10px;
    margin-top: 20px;
  }

  meterreading-wrapper {
    float: right;
  }

  .meter-readings  th, td {
      padding: 10px;
      border-bottom: 1px solid #ddd;
  }

  .row-main-meter {
    background-color: #f0f8ff;
  }

  .facility-header {
    // Classic UI style consumes --severity-stops (set by the inline
    // facilityStyleHasAlerts) as a horizontal full-width gradient.
    // Solid-colour cases emit "0%..100% same colour" so the gradient
    // pipeline degenerates to a flat fill. Default fallback = green.
    background: linear-gradient(90deg, var(--severity-stops, rgba(127,232,127,1) 0%, rgba(127,232,127,1) 100%));
    padding: 10px 10px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 1px 0 #ccc;
    z-index: 0;
  }

  .facility-header-suspect {
    background: #FBC742;
  }

  .facility-header-sub-suspect {
    //background: #FBC742;
    background: rgb(251,199,66);
    background: linear-gradient(90deg, v-bind(facilityGradient));
  }

  .facility-header-inactive {
    background: #F2F2F7;
  }

  .facility-title {
    font-weight: 800;
    margin-right: 10px;
  }

 .facility-name {
    font-weight: 600;
    margin-left: 10px;
    margin-right: 10px;
  }

  .facility-time {
    margin-top: 6px;
    font-size: 80%;
  }

  .facility-detail-wrapper {
      float:right;
  }
  .facility-details {
    position: absolute;
    top: -10px;
    /* 85px keeps the decorative house image clear of the icon stack in the
       header (location + alert + edit pencil), which grew with the pencil */
    right: 85px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 20px;
    margin-left: 20px;
    z-index: 1;
  }
  .location-image {
    width: 20px;
    height: 20px;
    text-align: center;
    position: relative;
    z-index: 1;
  }

  .location-wrapper {
      float:right;
      width: 25px;
      height: 25px;
      z-index: 0;
  }

  /* edit pencil in the box titles (facility/controller/sensor) — placed
     in the DOM AFTER the alert wrapper so the float stacks it to the LEFT
     of the alert icon, matching the iOS layout */
  .edit-wrapper {
      float:right;
      width: 25px;
      height: 25px;
      /* the alert badge (.alert-reason-number) hangs 10px left over its
         icon — keep the pencil clear of it */
      margin-right: 10px;
      z-index: 0;
      text-align: center;
  }

  .edit-icon {
      cursor: pointer;
      font-size: 17px;
      margin-top: 2px;
      opacity: 0.45;
  }

  .edit-icon:hover {
      opacity: 1;
  }

  .facility-image {
      width: 96px;
      height: 96px;
      margin-right: 10px;
      margin-left: 10px;
  }

  .alert-reason-wrapper {
      float:right;
      width: 25px;
      height: 25px;
      z-index: 0;
    }

  .alert-reason-number {
    text-align: center;
    position: relative;
    left: -10px;
    top: -15px;
    width: 15px;
    height: 15px;
    font-weight: 600;
    font-size: 80%;
    color: white;
    background: red;
    z-index: 2;
    border-radius: 20px;
    border-width: 1px;
  }

  .alert-reason-icon {
     text-align: center;
     position: relative;
     z-index: 1;
  }

  .facility-reason-number-inactive {
    display: none;
  }

  .device-reason-number-inactive {
      display: none;
  }

  .device-wrapper {
     display: grid;
     grid-template-columns: repeat(1, 1fr);
     column-gap: 10px;
     row-gap: 10px;
  }

  .device-item {
    overflow: hidden;
    // Classic UI style consumes --severity-stops (set by inline
    // deviceStyleHasAlerts / sensorStyleAlertStatus) as a horizontal
    // gradient. Default fallback = green.
    background: linear-gradient(90deg, var(--severity-stops, rgba(127,232,127,1) 0%, rgba(127,232,127,1) 100%));
    padding: 10px 10px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 1px 0 #ccc;
    margin-top: 20px;

    .device-headline {
      ;
    }

    .device-name {
      font-weight: 600;
      margin-left: 10px;
      margin-right: 10px;
    }

    .device-time {
      margin-top: 6px;
      font-size: 80%;
    }
  }

  .device-item-suspect {
    background: #FBC742;
  }

  .device-item-sub-suspect {
    //background: #FBC742;
    background: rgb(251,199,66);
    background: linear-gradient(90deg, v-bind(deviceGradient));
  }

  .device-item-inactive {
    background: #F2F2F7;
  }

  .collections-wrapper {
    margin-top: 20px;
  }

  .sensor-wrapper {
     display: grid;
     grid-template-columns: repeat(2, 1fr);
     column-gap: 10px;
     row-gap: 10px;

     // At viewport widths where a third 237px-ish card comfortably
     // fits next to the two existing ones, switch to a 3-column
     // grid. Threshold = 2×237 + 1×10 (current 2-card layout) + 237
     // + 10 (one more card + gap) ≈ 731, rounded to 729 to match
     // the user's observed dashboard breakpoint. Cards continue to
     // stretch via 1fr at any width.
     @media (min-width: 729px) {
       grid-template-columns: repeat(3, 1fr);
     }
  }

  .sensor-item-headline {
    overflow: hidden;
    // Classic UI style consumes --severity-stops (set by the inline
    // sensorStyleAlertStatus) as a horizontal gradient.
    background: linear-gradient(90deg, var(--severity-stops, rgba(127,232,127,1) 0%, rgba(127,232,127,1) 100%));
    padding: 10px 10px;
    border-radius: 10px 10px 0 0;
    margin: 0;
    /* box-shadow: 0 1px 0 #ccc; */
  }

  .sensor-name {
    font-weight: 600;
    margin-left: 10px;
    margin-right: 10px;
  }

  .sensor-meterinfo {
    font-weight: 100;
    margin-left: 10px;
    margin-right: 10px;
  }

  sensor-time {
    margin-top: 6px;
  }

  .sensor-item-suspect {
    background: #FBC742;
  }

  .sensor-item-inactive {
    background: #F2F2F7;
  }

  .sensor-item-content {
    overflow: hidden;
    background: #white;
    padding: 10px 10px;
    border: 1px solid #808080;
    border-top: none;
    border-radius: 0 0 10px 10px;
    margin: 0;
    /* box-shadow: 0 1px 0 #ccc; */
  }

  .sensor-item-value {
    text-align: center;
    font-weight: 600;
    font-size: 123%;
  }

  .sensor-item-unit {
    font-size: 80%;
  }

  .sensor-item-system {
    text-align: center;
    font-size: 80%;
  }

  .sensor-item-time {
    text-align: center;
    font-size: 80%;
  }

  /* formula line of computed sensors ("Hauptzähler − Unterzähler") */
  .sensor-item-formula {
    text-align: center;
    font-weight: 600;
  }

  .sensor-value-content {
    overflow: hidden;
    background: #white;
    padding: 10px 10px;
    border: 1px solid #808080;
    border-radius: 10px 10px 10px 10px;
    margin: 0;
    /* box-shadow: 0 1px 0 #ccc; */
  }

.sensor-value-content-not-hidden {
    overflow: visible;
    background: #white;
    padding: 10px 10px;
    border: 1px solid #808080;
    border-radius: 10px 10px 10px 10px;
    margin: 0;
    /* box-shadow: 0 1px 0 #ccc; */
  }
  .graph-content {
    // Span every column of the parent sensor-wrapper, regardless of
    // whether the responsive grid is currently rendering 2 or 3
    // columns. `1 / -1` = from first grid line to last.
    grid-column: 1 / -1;
    min-height: 100px;
  }

  /* Verbraucher + Chart-Beobachtungen */
  .appliance-section {
    margin-top: 10px;
  }
  .appliance-head,
  .observation-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5em;
    margin-bottom: 6px;
  }
  .appliance-title,
  .observation-title {
    font-weight: 600;
  }
  .appliance-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    align-items: baseline;
    margin-top: 4px;
  }
  .appliance-row-label {
    font-size: 80%;
    min-width: 7em;
  }
  .appliance-badge {
    background: #e9ecef;
    color: #212529;
    font-weight: 500;
    font-size: 85%;

    &.clickable {
      cursor: pointer;
    }
  }
  .observation-list {
    margin-top: 12px;
  }
  .observation-table {
    font-size: 85%;
    margin-bottom: 0;

    td, th {
      vertical-align: middle;
    }
  }
  .observation-note {
    max-width: 18em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .observation-actions .edit-icon {
    cursor: pointer;
    margin-left: 0.5em;
  }

  .meter-reading {
    margin-top: 20px;
  }

  .centeredText {
    margin: auto;
    padding: 10px;
  }

 .spacer {
    width: 100px;
  }

  .smallText {
      font-size: 9px;
      font-weight: 400;
  }

  #reloadContainer {
    width: 32px;
    height: 32px;
    position: relative;
  }
  #reloadText,
  #infoReload {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  #reloadText {
    font-size: 10px;
    margin: 8px;
    font-weight: 400;
  }
  #infoReload {
    z-index: 10;
  }
  #smallRefreshText {
      font-size: 9px;
      color: #929292;
      margin-bottom: 15px;
      font-weight: 400;
    }
}

// ─── Subtle UI style ──────────────────────────────────────────────────────────
// Cards drop the full-bg severity gradient and adopt a 5px vertical
// severity strip on the left edge instead. The strip carries the same
// colour stops as the classic gradient (vertical orientation gives more
// resolution per card than the horizontal full-bg variant). All strips
// read their colours from the inherited --severity-stops custom
// property — set by the JS gradient builders via inline :style on the
// facility / device / sensor-card containers. Activated by setting
// data-ui-style="subtle" on <html> — see App.vue + the app.ui-style
// backend property.
[data-ui-style="subtle"] {
  // Strip = 8px wide so that even a small severity slice (one alerted
  // sensor in a five-sensor device, ~20% of card height) stays
  // visible after the corner radius clips the top. Radius matches
  // Bootstrap's --bs-border-radius (≈6px) for consistency with the
  // rest of the UI. Values are inlined (not factored into custom
  // properties) because Vue's scoped CSS appends [data-v-xxx] to
  // selectors — declaring vars at the [data-ui-style="subtle"] root
  // would target [data-ui-style="subtle"][data-v-xxx] which never
  // matches <html>, leaving the vars undefined for descendants.
  .facility-header,
  .device-item,
  .sensor-card {
    position: relative;
    // Explicit white-ish card surface. The body bg sits one notch
    // darker (see App.vue's [data-ui-style="subtle"] body rule), so
    // the card visually "lifts" off the page without needing a
    // border or shadow at rest. Dark mode overrides this further
    // down with a slightly-lighter-than-page dark surface plus a
    // faint white inset highlight on the bottom-right edge —
    // "lit from below-right" feel.
    background: #ffffff;
    color: var(--bs-body-color);
    overflow: hidden;
    border: none;
    border-radius: var(--bs-border-radius, 6px);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 8px;
      pointer-events: none;
      background: linear-gradient(
        180deg,
        var(--severity-stops, rgba(127, 232, 127, 1) 0%, rgba(127, 232, 127, 1) 100%)
      );
    }
  }

  // Neutralise the inner card sections so the wrapper's neutral bg +
  // strip dominate. The headline keeps its padding but loses the
  // colored gradient; content drops its own border so it merges with
  // the wrapper's outline. Padding-left moves text clear of the strip.
  .sensor-card {
    margin: 0;

    .sensor-item-headline {
      background: transparent;
      padding-left: 16px;
      border-radius: 0;
    }
    .sensor-item-content {
      background: transparent;
      border: none;
      border-radius: 0;
      padding-left: 16px;
    }
  }

  .facility-header,
  .device-item {
    padding-left: 16px;
  }

  // Clickable-card affordance — persistent subtle shadow lets the
  // user spot interactive cards at a glance (without having to
  // hover each one), the hover state confirms with a slightly
  // stronger shadow + 1px lift. Suppresses the global
  // .pointer:hover effect (2px black ring + brightness dim) inside
  // subtle mode — too heavy for the flat neutral surface.
  //
  // Uses :has() to detect a clickable inner element on the
  // .sensor-card wrapper (the .pointer class sits on the inner
  // .sensor-item-headline, not the wrapper itself). :has() is
  // supported in all evergreen browsers used by the dashboard.
  .pointer:hover {
    box-shadow: none !important;
    filter: none !important;
  }

  .facility-header.pointer,
  .sensor-card.pointer {
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.18s ease, transform 0.18s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
      transform: translateY(-1px);
    }
  }
}

// Dark theme tuning for subtle mode: cards switch to a surface that
// sits one notch lighter than the (already deeper) page bg, and a
// faint white inset highlight on the bottom-right edge gives them
// the "lit from below-right" raised feel. Light mode achieves the
// same lift purely via card-vs-page brightness contrast, so it
// doesn't need this highlight (and a white inset on a white card
// would be invisible anyway).
[data-bs-theme="dark"][data-ui-style="subtle"] {
  .facility-header,
  .device-item,
  .sensor-card {
    background: #2b2b2b;
    box-shadow: inset -1px -1px 0 rgba(255, 255, 255, 0.07);
  }

  .facility-header.pointer,
  .sensor-card.pointer {
    box-shadow:
      inset -1px -1px 0 rgba(255, 255, 255, 0.07),
      0 1px 3px rgba(0, 0, 0, 0.35);

    &:hover {
      box-shadow:
        inset -1px -1px 0 rgba(255, 255, 255, 0.07),
        0 4px 12px rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
